<template>
	<section class="dp-layout AccessControl-Rules">
		<!-- 
    <section class="left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
		<section class="dp-left">
			<DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!-- 日常规则 / 临时规则切换。创建于 2026-10-12 -->
			<div class="ac-tab-bar" v-if="canViewTempRule">
				<el-radio-group v-model="activeTab" size="small" @change="onTabChange">
					<el-radio-button label="daily">日常规则</el-radio-button>
					<el-radio-button label="temp">临时规则</el-radio-button>
				</el-radio-group>
			</div>
			<!--工具条-->
			<toolbar v-show="activeTab === 'daily'" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
			<!-- 临时规则工具条：复用工具条样式并占同一位置，切换 Tab 不跳动。最后更新：2026-10-12 -->
			<el-col v-if="activeTab === 'temp'" :span="24" class="toolbar toolbar--premium">
				<el-form :inline="true" class="toolbar-form ac-temp-toolbar" @submit.native.prevent>
					<el-input v-model="tempFilters.title" size="small" placeholder="标题" clearable style="width: 200px;"
						@keyup.enter.native="loadTempRules(1)" @clear="loadTempRules(1)"></el-input>
					<el-select v-model="tempFilters.status" size="small" clearable placeholder="全部状态" style="width: 140px;"
						@change="loadTempRules(1)">
						<el-option v-for="item in tempStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
					<el-button size="small" icon="el-icon-search" @click="loadTempRules(1)">查询</el-button>
					<el-button v-if="canEditTempRule" type="primary" size="small" icon="el-icon-plus" @click="openTempForm(null)">新增临时规则</el-button>
				</el-form>
			</el-col>
			<div class="scheme-page-bar ac-temp-info-bar" v-if="DepartmentId && activeTab === 'temp'">
				<i class="el-icon-info"></i>
				<span>节假日、活动提前放学等：到「下发时间」自动下发天波，到「删除时间」自动从天波删除，平台记录保留</span>
			</div>
			<div class="scheme-page-bar" v-if="DepartmentId && activeTab === 'daily'">
				<el-tag size="small" :type="schoolSchemeSlot === 2 ? 'warning' : 'success'">
					当前生效：{{ activeSchemeName }}
				</el-tag>
				<el-tag v-if="!schemeHasBackup" size="mini" type="info">尚未创建备用</el-tag>
				<el-tag v-else size="mini" type="info">备用：{{ inactiveSchemeName }}</el-tag>
				<div class="scheme-page-actions">
					<el-button type="primary" size="mini" :loading="schemeBusy" @click="openSwitchSchemeDialog">
						切换生效方案
					</el-button>
					<el-button type="success" plain size="mini" :loading="schemeBusy" @click="createBackup">
						创建/更新备用
					</el-button>
					<el-button type="text" size="mini" icon="el-icon-edit" @click="renameSchemes">改方案名</el-button>
				</div>
			</div>
			<el-dialog
				title="切换生效方案"
				:visible.sync="switchSchemeDialogVisible"
				width="460px"
				append-to-body
				custom-class="scheme-switch-dialog">
				<div class="scheme-pick">
					<div
						class="scheme-pick-card"
						:class="{
							'is-active': switchTargetSlot === 1,
							'is-current': schoolSchemeSlot === 1
						}"
						@click="switchTargetSlot = 1">
						<div class="scheme-pick-card__top">
							<i class="el-icon-s-flag scheme-pick-card__icon"></i>
							<span v-if="schoolSchemeSlot === 1" class="scheme-pick-badge">当前生效</span>
						</div>
						<div class="scheme-pick-card__name">{{ schemeSlot1Name }}</div>
						<div class="scheme-pick-card__desc">方案一</div>
					</div>
					<div
						class="scheme-pick-card"
						:class="{
							'is-active': switchTargetSlot === 2,
							'is-current': schoolSchemeSlot === 2,
							'is-disabled': !schemeHasBackup
						}"
						@click="schemeHasBackup && (switchTargetSlot = 2)">
						<div class="scheme-pick-card__top">
							<i class="el-icon-s-opportunity scheme-pick-card__icon"></i>
							<span v-if="schoolSchemeSlot === 2" class="scheme-pick-badge">当前生效</span>
							<span v-else-if="!schemeHasBackup" class="scheme-pick-badge is-muted">未创建备用</span>
						</div>
						<div class="scheme-pick-card__name">{{ schemeSlot2Name }}</div>
						<div class="scheme-pick-card__desc">{{ schemeHasBackup ? '方案二 · 备用' : '请先创建备用' }}</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="switchSchemeDialogVisible = false">取消</el-button>
					<el-button type="primary" size="small" :loading="schemeBusy" @click="confirmSwitchScheme">确定切换</el-button>
				</div>
			</el-dialog>
			<div class="dp-dept-hint">
				<span class="dp-dept-hint__label">所属机构</span>
				<span class="dp-dept-hint__value">{{ currentDepartmentName || '全部' }}</span>
			</div>
			<!-- 临时规则列表。创建于 2026-10-12 -->
			<template v-if="activeTab === 'temp'">
				<div class="tbl-scroll-host">
					<el-table key="tempRuleTable" :data="tempRules" v-loading="tempLoading" class="custom-tbl" height="100%" style="width: 100%" row-key="Id">
						<el-table-column prop="Title" label="标题" min-width="160" show-overflow-tooltip></el-table-column>
						<el-table-column label="类型" width="90">
							<template slot-scope="scope">{{ tempReasonLabel(scope.row.ReasonType) }}</template>
						</el-table-column>
						<el-table-column label="下发时间" width="150">
							<template slot-scope="scope">
								<span :class="['ac-time-chip', tempTimeMeta(scope.row, 'push').cls]" :title="tempTimeMeta(scope.row, 'push').tip">
									{{ formatDateTime(scope.row.PushAt) }}
								</span>
							</template>
						</el-table-column>
						<el-table-column label="删除时间" width="150">
							<template slot-scope="scope">
								<span :class="['ac-time-chip', tempTimeMeta(scope.row, 'delete').cls]" :title="tempTimeMeta(scope.row, 'delete').tip">
									{{ formatDateTime(scope.row.DeleteAt) }}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="Place" label="生效场所" min-width="110" show-overflow-tooltip></el-table-column>
						<el-table-column prop="Priority" label="优先级" width="70" align="center"></el-table-column>
						<el-table-column label="状态" width="110" align="center">
							<template slot-scope="scope">
								<el-tooltip v-if="scope.row.LastError" :content="scope.row.LastError" placement="top">
									<el-tag size="mini" :type="tempStatusMeta(scope.row.Status).type">
										{{ tempStatusMeta(scope.row.Status).label }} <i class="el-icon-warning-outline"></i>
									</el-tag>
								</el-tooltip>
								<el-tag v-else size="mini" :type="tempStatusMeta(scope.row.Status).type">
									{{ tempStatusMeta(scope.row.Status).label }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="第三方ID" width="110">
							<template slot-scope="scope">
								<el-tooltip v-if="scope.row.ThirdPartyId > 0 && scope.row.Status === 'Finished'" content="已从天波删除，仅保留原 ID 备查" placement="top">
									<span class="ac-third-id--removed">{{ scope.row.ThirdPartyId }}</span>
								</el-tooltip>
								<span v-else-if="scope.row.ThirdPartyId > 0">{{ scope.row.ThirdPartyId }}</span>
								<span v-else class="ac-empty-dash">-</span>
							</template>
						</el-table-column>
						<el-table-column v-if="canEditTempRule" label="操作" width="260" align="center" fixed="right">
							<template slot-scope="scope">
								<el-button type="text" size="mini" @click="openTempForm(scope.row)">
									{{ scope.row.Status === 'Finished' ? '复制新建' : '编辑' }}
								</el-button>
								<el-button v-if="scope.row.Status === 'PendingPush' || scope.row.Status === 'Failed'"
									type="text" size="mini" @click="pushTempNow(scope.row)">立即下发</el-button>
								<el-button v-if="scope.row.Status !== 'Finished'"
									type="text" size="mini" class="table-op-link--danger" @click="finishTempNow(scope.row)">提前结束</el-button>
								<el-button type="text" size="mini" class="table-op-link--danger" @click="deleteTemp(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="loadTempRules"
						:current-page="tempPage" :page-size="10" :total="tempTotal" style="float: right">
					</el-pagination>
				</el-col>
			</template>
			<!--列表-->
			<template v-else>
			<div class="tbl-scroll-host">
			<el-table key="dailyRuleTable" :data="users" v-loading="listLoading" @selection-change="handleSelectionChange"
				@select="dialogCheck" @row-click="selectCurrentRow" ref="table"
				class="custom-tbl" height="100%" style="width: 100%" row-key="Id">
				<el-table-column type="selection" width="50"> </el-table-column>
				<el-table-column prop="RuleName" label="规则名称" width="">
				</el-table-column>
				<el-table-column label="第三方ID" width="110" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.ThirdPartyId > 0" size="mini" type="success">
							{{ scope.row.ThirdPartyId }}
						</el-tag>
						<el-tag v-else size="mini" type="info">未同步</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="Place" label="生效场所" width="">
				</el-table-column>
				<el-table-column label="出设备" width="">
					<template slot-scope="scope">
						<el-button
							v-if="scope.row.OutDeviceSns && scope.row.OutDeviceSns.length"
							type="text"
							size="small"
							icon="el-icon-monitor"
							class="ac-device-link-btn"
							@click.stop="openDeviceViewDialog(scope.row, 'out')">
							已选 {{ scope.row.OutDeviceSns.length }} 台设备
						</el-button>
						<span v-else class="ac-empty-dash">-</span>
					</template>
				</el-table-column>
				<el-table-column label="入设备" width="">
					<template slot-scope="scope">
						<el-button
							v-if="scope.row.InDeviceSns && scope.row.InDeviceSns.length"
							type="text"
							size="small"
							icon="el-icon-monitor"
							class="ac-device-link-btn"
							@click.stop="openDeviceViewDialog(scope.row, 'in')">
							已选 {{ scope.row.InDeviceSns.length }} 台设备
						</el-button>
						<span v-else class="ac-empty-dash">-</span>
					</template>
				</el-table-column>
				<el-table-column prop="Priority" label="优先级" width="">
				</el-table-column>
				<el-table-column label="启用" width="80" align="center">
					<template slot-scope="scope">
						<el-switch
							:value="scope.row.IsEnabled !== false"
							active-color="#13ce66"
							@change="(val) => toggleAccessEnabled(scope.row, val)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="Description" label="备注" width="">
				</el-table-column>
			</el-table>
			</div>
			<!--工具条-->
			<el-col :span="24" class="toolbar">
				<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
					:page-size="10" :total="total" style="float: right">
				</el-pagination>
			</el-col>
			</template>
			<!--编辑界面-->
			<el-dialog title="编辑门禁规则" :visible.sync="editFormVisible"
				:close-on-click-modal="false" width="60%" custom-class="ac-rule-dialog">
				<el-form :model="editForm" label-width="80px" :rules="FormRules" ref="editForm" class="editForm"
					v-if="editForm">
					<!-- 基础信息与控制属性：两列栅格布局。最后更新：2026-09-08 -->
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="规则名称" prop="RuleName">
								<el-input v-model="editForm.RuleName" maxlength="64" auto-complete="off" placeholder="请输入规则名称"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="生效场所" prop="Place">
								<el-input v-model="editForm.Place" maxlength="64" auto-complete="off" placeholder="如：学校大门"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="通行状态" prop="PassStatus">
								<div class="pass-status-field-wrap">
									<el-radio-group v-model="editForm.PassStatus" @input="onMainPassStatusChange('editForm', $event)">
										<el-radio-button :label="1">允许通行</el-radio-button>
										<el-radio-button :label="2">禁止通行</el-radio-button>
									</el-radio-group>
									<div class="pass-status-safe-tip">推荐：默认禁止通行，再由子规则按时段放行</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="优先级">
								<div class="priority-field-wrap">
									<el-select v-model="editForm.Priority" placeholder="请选择" style="width: 100%;">
										<el-option v-for="item in 10" :key="item - 1" :label="item - 1" :value="item - 1">
										</el-option>
									</el-select>
									<span class="priority-tip">不选默认 0，优先级依次递增，9 最高</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="备注">
						<el-input v-model="editForm.Description" type="textarea" :rows="2" maxlength="64" show-word-limit auto-complete="off" placeholder="选填，请输入备注说明"></el-input>
					</el-form-item>
					<el-form-item label="关联人员" required class="ac-person-form-item">
						<el-button type="" @click="addPersion">编辑</el-button>
						<span class="tip ac-person-tip ac-person-tip--empty" v-if="!hasPersonScope(editForm)">请选择关联部门或人员</span>
						<span class="tip isSelect ac-person-tip" v-else>
							<span v-if="editForm.DeptIds && editForm.DeptIds.length">
								<span>已关联 {{ editForm.DeptIds.length }} 个部门</span>
							</span>
							<span v-if="
								editForm.DeptIds &&
								editForm.DeptIds.length &&
								editForm.PersonIds &&
								editForm.PersonIds.length
							">，且</span>
							<span v-if="editForm.PersonIds && editForm.PersonIds.length">已关联 {{ editForm.PersonIds.length }} 位人员</span>
						</span>
					</el-form-item>
					<!-- 出/入门禁规则上下排列。最后更新：2026-10-09 -->
					<div class="ac-rule-tabs-wrap">
						<!-- 出门禁面板：集成单行两端分布工具栏。最后更新：2026-09-08 -->
						<div class="ac-direction-panel">
							<div class="ac-direction-toolbar">
								<div class="ac-direction-toolbar-left">
									<span class="ac-toolbar-label"><i class="el-icon-right"></i> 出门禁设备：</span>
									<el-button size="small" @click="addDevice(false)">编辑设备</el-button>
									<span class="tip ac-action-tip" v-if="!editForm.OutDeviceSns || !editForm.OutDeviceSns.length">请选择设备</span>
									<span class="tip isSelect ac-action-tip" v-else>
										已选择 <strong>{{ editForm.OutDeviceSns.length }}</strong> 台出设备
									</span>
								</div>
								<div class="ac-direction-toolbar-right">
									<el-button type="primary" size="small" icon="el-icon-plus" @click="addRule(1)">添加门禁规则</el-button>
								</div>
							</div>
							<el-form-item label="" class="ac-rule-table-item">
								<el-table style="width: 100%" :data="editFormOutRules" empty-text="暂无出门禁规则">
									<!-- <el-table-column label="规则ID" prop="id"></el-table-column> -->
									<el-table-column label="第三方ID" width="110" align="center">
										<template slot-scope="scope">
											<el-tag v-if="scope.row.thirdPartyId > 0" size="mini" type="success">
												{{ scope.row.thirdPartyId }}
											</el-tag>
											<el-tag v-else size="mini" type="info">未同步</el-tag>
										</template>
									</el-table-column>
									<el-table-column label="人员类型" min-width="200">
										<template slot-scope="scope">
											<div class="ac-role-tags"><span v-for="role in (scope.row.userRole || [])" :key="role" class="ac-role-tag" :class="'ac-role-tag--' + role">{{ userRoleMap.get(role) || '其他' }}</span></div>
										</template>
									</el-table-column>
									<el-table-column label="周期">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ listToString(scope.row.weekNo, weekNoMap) }}</span>
										</template>
									</el-table-column>
									<el-table-column label="时间">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ scope.row.timePeriod }}</span>
										</template>
									</el-table-column>
									<el-table-column label="通行状态" width="100">
										<template slot-scope="scope">
											{{
												scope.row.passStatus == 1
													? '允许通行'
													: scope.row.passStatus == 2
														? '禁止通行'
														: '其他'
											}}
										</template>
									</el-table-column>
									<el-table-column label="操作" width="150" align="center">
										<template slot-scope="scope">
											<div class="ac-rule-row-actions">
												<el-button size="mini" @click="handleEditRule(1, scope.row)">编辑</el-button>
												<el-button size="mini" type="danger" @click="handleDeleteRule(scope.row)">删除</el-button>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>

						<!-- 入门禁面板：集成单行两端分布工具栏。最后更新：2026-09-08 -->
						<div class="ac-direction-panel">
							<div class="ac-direction-toolbar">
								<div class="ac-direction-toolbar-left">
									<span class="ac-toolbar-label"><i class="el-icon-back"></i> 入门禁设备：</span>
									<el-button size="small" @click="addDevice(true)">编辑设备</el-button>
									<span class="tip ac-action-tip" v-if="!editForm.InDeviceSns || !editForm.InDeviceSns.length">请选择设备</span>
									<span class="tip isSelect ac-action-tip" v-else>
										已选择 <strong>{{ editForm.InDeviceSns.length }}</strong> 台入设备
									</span>
								</div>
								<div class="ac-direction-toolbar-right">
									<el-button type="primary" size="small" icon="el-icon-plus" @click="addRule(2)">添加门禁规则</el-button>
								</div>
							</div>
							<el-form-item label="" class="ac-rule-table-item">
								<el-table style="width: 100%" :data="editFormInRules" empty-text="暂无入门禁规则">
									<!-- <el-table-column label="规则ID" prop="id"></el-table-column> -->
									<el-table-column label="第三方ID" width="110" align="center">
										<template slot-scope="scope">
											<el-tag v-if="scope.row.thirdPartyId > 0" size="mini" type="success">
												{{ scope.row.thirdPartyId }}
											</el-tag>
											<el-tag v-else size="mini" type="info">未同步</el-tag>
										</template>
									</el-table-column>
									<el-table-column label="人员类型" min-width="200">
										<template slot-scope="scope">
											<div class="ac-role-tags"><span v-for="role in (scope.row.userRole || [])" :key="role" class="ac-role-tag" :class="'ac-role-tag--' + role">{{ userRoleMap.get(role) || '其他' }}</span></div>
										</template>
									</el-table-column>
									<el-table-column label="周期">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ listToString(scope.row.weekNo, weekNoMap) }}</span>
										</template>
									</el-table-column>
									<el-table-column label="时间">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ scope.row.timePeriod }}</span>
										</template>
									</el-table-column>
									<el-table-column label="通行状态" width="100">
										<template slot-scope="scope">
											{{
												scope.row.passStatus == 1
													? '允许通行'
													: scope.row.passStatus == 2
														? '禁止通行'
														: '其他'
											}}
										</template>
									</el-table-column>
									<el-table-column label="操作" width="150" align="center">
										<template slot-scope="scope">
											<div class="ac-rule-row-actions">
												<el-button size="mini" @click="handleEditRule(2, scope.row)">编辑</el-button>
												<el-button size="mini" type="danger" @click="handleDeleteRule(scope.row)">删除</el-button>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="editFormVisible = false" :disabled="editLoading">取消</el-button>
					<el-button type="primary" @click="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>
			<!--新增界面-->
			<el-dialog title="新增门禁规则" :visible.sync="addFormVisible"
				:close-on-click-modal="false" width="60%" custom-class="ac-rule-dialog">
				<el-form :model="addForm" label-width="80px" :rules="FormRules" ref="addForm" class="addForm"
					v-if="addForm">
					<!-- 基础信息与控制属性：两列栅格布局。最后更新：2026-09-08 -->
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="规则名称" prop="RuleName">
								<el-input v-model="addForm.RuleName" maxlength="64" auto-complete="off" placeholder="请输入规则名称"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="生效场所" prop="Place">
								<el-input v-model="addForm.Place" maxlength="64" auto-complete="off" placeholder="如：学校大门"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="通行状态" prop="PassStatus">
								<div class="pass-status-field-wrap">
									<el-radio-group v-model="addForm.PassStatus" @input="onMainPassStatusChange('addForm', $event)">
										<el-radio-button :label="1">允许通行</el-radio-button>
										<el-radio-button :label="2">禁止通行</el-radio-button>
									</el-radio-group>
									<div class="pass-status-safe-tip">推荐：默认禁止通行，再由子规则按时段放行</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="优先级">
								<div class="priority-field-wrap">
									<el-select v-model="addForm.Priority" placeholder="请选择" style="width: 100%;">
										<el-option v-for="item in 10" :key="item - 1" :label="item - 1" :value="item - 1">
										</el-option>
									</el-select>
									<span class="priority-tip">不选默认 0，优先级依次递增，9 最高</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="备注">
						<el-input v-model="addForm.Description" type="textarea" :rows="2" maxlength="64" show-word-limit auto-complete="off" placeholder="选填，请输入备注说明"></el-input>
					</el-form-item>
					<el-form-item label="关联人员" required class="ac-person-form-item">
						<el-button type="" @click="addPersion">编辑</el-button>
						<span class="tip ac-person-tip ac-person-tip--empty" v-if="!hasPersonScope(addForm)">请选择关联部门或人员</span>
						<span class="tip isSelect ac-person-tip" v-else>
							<span v-if="addForm.DeptIds && addForm.DeptIds.length">
								<span>已关联 {{ addForm.DeptIds.length }} 个部门</span>
							</span>
							<span v-if="
								addForm.DeptIds &&
								addForm.DeptIds.length &&
								addForm.PersonIds &&
								addForm.PersonIds.length
							">，且</span>
							<span v-if="addForm.PersonIds && addForm.PersonIds.length">已关联 {{ addForm.PersonIds.length }} 位人员</span>
						</span>
					</el-form-item>
					<!-- 出/入门禁规则上下排列。最后更新：2026-10-09 -->
					<div class="ac-rule-tabs-wrap">
						<!-- 出门禁面板：集成单行两端分布工具栏。最后更新：2026-09-08 -->
						<div class="ac-direction-panel">
							<div class="ac-direction-toolbar">
								<div class="ac-direction-toolbar-left">
									<span class="ac-toolbar-label"><i class="el-icon-right"></i> 出门禁设备：</span>
									<el-button size="small" @click="addDevice(false)">编辑设备</el-button>
									<span class="tip ac-action-tip" v-if="!addForm.OutDeviceSns || !addForm.OutDeviceSns.length">请选择设备</span>
									<span class="tip isSelect ac-action-tip" v-else>
										已选择 <strong>{{ addForm.OutDeviceSns.length }}</strong> 台出设备
									</span>
								</div>
								<div class="ac-direction-toolbar-right">
									<el-button type="primary" size="small" icon="el-icon-plus" @click="addRule(1)">添加门禁规则</el-button>
								</div>
							</div>
							<el-form-item label="" class="ac-rule-table-item">
								<el-table style="width: 100%" :data="addFormOutRules" empty-text="暂无出门禁规则">
									<!-- <el-table-column label="规则ID" prop="id"></el-table-column> -->
									<el-table-column label="第三方ID" width="110" align="center">
										<template slot-scope="scope">
											<el-tag v-if="scope.row.thirdPartyId > 0" size="mini" type="success">
												{{ scope.row.thirdPartyId }}
											</el-tag>
											<el-tag v-else size="mini" type="info">未同步</el-tag>
										</template>
									</el-table-column>
									<el-table-column label="人员类型" min-width="200">
										<template slot-scope="scope">
											<div class="ac-role-tags"><span v-for="role in (scope.row.userRole || [])" :key="role" class="ac-role-tag" :class="'ac-role-tag--' + role">{{ userRoleMap.get(role) || '其他' }}</span></div>
										</template>
									</el-table-column>
									<el-table-column label="周期">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ listToString(scope.row.weekNo, weekNoMap) }}</span>
										</template>
									</el-table-column>
									<el-table-column label="时间">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ scope.row.timePeriod }}</span>
										</template>
									</el-table-column>
									<el-table-column label="通行状态" width="100">
										<template slot-scope="scope">
											{{
												scope.row.passStatus == 1
													? '允许通行'
													: scope.row.passStatus == 2
														? '禁止通行'
														: '其他'
											}}
										</template>
									</el-table-column>
									<el-table-column label="操作" width="150" align="center">
										<template slot-scope="scope">
											<div class="ac-rule-row-actions">
												<el-button size="mini" @click="handleEditRule(1, scope.row)">编辑</el-button>
												<el-button size="mini" type="danger" @click="handleDeleteRule(scope.row)">删除</el-button>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>

						<!-- 入门禁面板：集成单行两端分布工具栏。最后更新：2026-09-08 -->
						<div class="ac-direction-panel">
							<div class="ac-direction-toolbar">
								<div class="ac-direction-toolbar-left">
									<span class="ac-toolbar-label"><i class="el-icon-back"></i> 入门禁设备：</span>
									<el-button size="small" @click="addDevice(true)">编辑设备</el-button>
									<span class="tip ac-action-tip" v-if="!addForm.InDeviceSns || !addForm.InDeviceSns.length">请选择设备</span>
									<span class="tip isSelect ac-action-tip" v-else>
										已选择 <strong>{{ addForm.InDeviceSns.length }}</strong> 台入设备
									</span>
								</div>
								<div class="ac-direction-toolbar-right">
									<el-button type="primary" size="small" icon="el-icon-plus" @click="addRule(2)">添加门禁规则</el-button>
								</div>
							</div>
							<el-form-item label="" class="ac-rule-table-item">
								<el-table style="width: 100%" :data="addFormInRules" empty-text="暂无入门禁规则">
									<!-- <el-table-column label="规则ID" prop="id"></el-table-column> -->
									<el-table-column label="第三方ID" width="110" align="center">
										<template slot-scope="scope">
											<el-tag v-if="scope.row.thirdPartyId > 0" size="mini" type="success">
												{{ scope.row.thirdPartyId }}
											</el-tag>
											<el-tag v-else size="mini" type="info">未同步</el-tag>
										</template>
									</el-table-column>
									<el-table-column label="人员类型" min-width="200">
										<template slot-scope="scope">
											<div class="ac-role-tags"><span v-for="role in (scope.row.userRole || [])" :key="role" class="ac-role-tag" :class="'ac-role-tag--' + role">{{ userRoleMap.get(role) || '其他' }}</span></div>
										</template>
									</el-table-column>
									<el-table-column label="周期">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ listToString(scope.row.weekNo, weekNoMap) }}</span>
										</template>
									</el-table-column>
									<el-table-column label="时间">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ scope.row.timePeriod }}</span>
										</template>
									</el-table-column>
									<el-table-column label="通行状态" width="100">
										<template slot-scope="scope">
											{{
												scope.row.passStatus == 1
													? '允许通行'
													: scope.row.passStatus == 2
														? '禁止通行'
														: '其他'
											}}
										</template>
									</el-table-column>
									<el-table-column label="操作" width="150" align="center">
										<template slot-scope="scope">
											<div class="ac-rule-row-actions">
												<el-button size="mini" @click="handleEditRule(2, scope.row)">编辑</el-button>
												<el-button size="mini" type="danger" @click="handleDeleteRule(scope.row)">删除</el-button>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>
			<!-- 临时规则新增/编辑（同一弹窗）。创建于 2026-10-12 -->
			<el-dialog :title="tempForm && tempForm.Id ? '编辑临时规则' : '新增临时规则'" :visible.sync="tempFormVisible"
				:close-on-click-modal="false" width="60%" custom-class="ac-rule-dialog">
				<el-form :model="tempForm" label-width="80px" :rules="tempFormRules" ref="tempForm" v-if="tempForm">
					<el-alert v-if="tempForm.Status === 'ActiveOnTb'" type="warning" :closable="false" show-icon
						title="该临时规则已在天波生效，保存后会先从天波删除，再按新配置重新下发" class="ac-temp-alert"></el-alert>
					<el-form-item label="快速复制">
						<el-select v-model="tempCopySourceId" filterable clearable placeholder="从日常规则复制场所、设备、人员范围（可选）"
							:loading="dailyRuleOptionsLoading" style="width: 100%;" @change="copyFromDailyRule">
							<el-option v-for="item in dailyRuleOptions" :key="item.Id" :label="item.RuleName + (item.Place ? '（' + item.Place + '）' : '')" :value="item.Id"></el-option>
						</el-select>
					</el-form-item>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="标题" prop="Title">
								<el-input v-model="tempForm.Title" maxlength="64" placeholder="如：国庆放假、运动会提前放学"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="类型">
								<el-radio-group v-model="tempForm.ReasonType">
									<el-radio-button v-for="item in tempReasonOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="下发时间" prop="PushAt">
								<div :class="['ac-time-field', tempFormTimeMeta('push').cls]">
									<el-date-picker v-model="tempForm.PushAt" type="datetime" format="yyyy-MM-dd HH:mm"
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="到点自动下发天波" style="width: 100%;"></el-date-picker>
									<div v-if="tempFormTimeMeta('push').tip" class="ac-time-field__tip">{{ tempFormTimeMeta('push').tip }}</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="删除时间" prop="DeleteAt">
								<div :class="['ac-time-field', tempFormTimeMeta('delete').cls]">
									<el-date-picker v-model="tempForm.DeleteAt" type="datetime" format="yyyy-MM-dd HH:mm"
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="到点自动从天波删除" style="width: 100%;"></el-date-picker>
									<div v-if="tempFormTimeMeta('delete').tip" class="ac-time-field__tip">{{ tempFormTimeMeta('delete').tip }}</div>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="生效场所" prop="Place">
								<el-input v-model="tempForm.Place" maxlength="64" placeholder="如：学校大门"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="优先级">
								<div class="priority-field-wrap">
									<el-select v-model="tempForm.Priority" style="width: 100%;">
										<el-option v-for="item in 10" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
									</el-select>
									<span class="priority-tip">默认 9（最高）</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="通行状态">
						<el-radio-group v-model="tempForm.PassStatus">
							<el-radio-button :label="1">允许通行</el-radio-button>
							<el-radio-button :label="2">禁止通行</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="tempForm.Remark" type="textarea" :rows="2" maxlength="500" placeholder="选填"></el-input>
					</el-form-item>
					<el-form-item label="关联人员" required class="ac-person-form-item">
						<el-button @click="addPersion">编辑</el-button>
						<span class="tip ac-person-tip ac-person-tip--empty" v-if="!hasPersonScope(tempForm)">请选择关联部门或人员</span>
						<span class="tip isSelect ac-person-tip" v-else>
							<span v-if="tempForm.DeptIds && tempForm.DeptIds.length">已关联 {{ tempForm.DeptIds.length }} 个部门</span>
							<span v-if="tempForm.DeptIds && tempForm.DeptIds.length && tempForm.PersonIds && tempForm.PersonIds.length">，且</span>
							<span v-if="tempForm.PersonIds && tempForm.PersonIds.length">已关联 {{ tempForm.PersonIds.length }} 位人员</span>
						</span>
					</el-form-item>
					<div class="ac-temp-weekno-tip">
						<i class="el-icon-info"></i>
						天波子规则只能按「周几」配置。一周内的假期用一条临时规则即可：放假前一天按周几配提前放学「出」，返校日按周几配「入」。
					</div>
					<div class="ac-rule-tabs-wrap">
						<div v-for="dir in tempDirections" :key="dir.type" class="ac-direction-panel">
							<div class="ac-direction-toolbar">
								<div class="ac-direction-toolbar-left">
									<span class="ac-toolbar-label"><i :class="dir.icon"></i> {{ dir.label }}门禁设备：</span>
									<el-button size="small" @click="addDevice(dir.type === 2)">编辑设备</el-button>
									<span class="tip ac-action-tip" v-if="!(tempForm[dir.deviceKey] || []).length">请选择设备</span>
									<span class="tip isSelect ac-action-tip" v-else>
										已选择 <strong>{{ tempForm[dir.deviceKey].length }}</strong> 台{{ dir.label }}设备
									</span>
								</div>
								<div class="ac-direction-toolbar-right">
									<el-button type="primary" size="small" icon="el-icon-plus" @click="addRule(dir.type)">添加门禁规则</el-button>
								</div>
							</div>
							<el-form-item label="" class="ac-rule-table-item">
								<el-table style="width: 100%" :data="tempFormRulesByType(dir.type)" :empty-text="'暂无' + dir.label + '门禁规则'">
									<el-table-column label="第三方ID" width="110" align="center">
										<template slot-scope="scope">
											<el-tooltip v-if="scope.row.thirdPartyId > 0 && tempForm.Status === 'Finished'" content="已从天波删除，仅保留原 ID 备查" placement="top">
												<span class="ac-third-id--removed">{{ scope.row.thirdPartyId }}</span>
											</el-tooltip>
											<el-tag v-else-if="scope.row.thirdPartyId > 0" size="mini" type="success">{{ scope.row.thirdPartyId }}</el-tag>
											<el-tag v-else size="mini" type="info">未下发</el-tag>
										</template>
									</el-table-column>
									<el-table-column label="人员类型" min-width="200">
										<template slot-scope="scope">
											<div class="ac-role-tags"><span v-for="role in (scope.row.userRole || [])" :key="role" class="ac-role-tag" :class="'ac-role-tag--' + role">{{ userRoleMap.get(role) || '其他' }}</span></div>
										</template>
									</el-table-column>
									<el-table-column label="周期">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ listToString(scope.row.weekNo || [], weekNoMap) }}</span>
										</template>
									</el-table-column>
									<el-table-column label="时间">
										<template slot-scope="scope">
											<span class="ac-rule-time-highlight">{{ scope.row.timePeriod }}</span>
										</template>
									</el-table-column>
									<el-table-column label="通行状态" width="100">
										<template slot-scope="scope">{{ scope.row.passStatus == 2 ? '禁止通行' : '允许通行' }}</template>
									</el-table-column>
									<el-table-column label="操作" width="150" align="center">
										<template slot-scope="scope">
											<div class="ac-rule-row-actions">
												<el-button size="mini" @click="handleEditRule(dir.type, scope.row)">编辑</el-button>
												<el-button size="mini" type="danger" @click="handleDeleteRule(scope.row)">删除</el-button>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="tempFormVisible = false">取消</el-button>
					<el-button type="primary" @click="submitTempForm" :loading="tempSaving">保存</el-button>
				</div>
			</el-dialog>
			<!-- 人员添加弹窗。重构为【按部门】、【学生】、【教职工】三大独立 Tab。最后更新：2026-09-08 -->
			<el-dialog title="选择人员" :visible.sync="personVisible" :close-on-click-modal="false"
				width="1100px" top="6vh" custom-class="ac-picker-dialog ac-person-dialog"
				:destroy-on-close="true">
				<div class="ac-person-dialog-container" :key="'ac-person-picker-' + personPickerEpoch">
					<!-- 顶部导航与上下文信息栏（左侧Tab与当前组织紧密相依，右侧展示系统提示与说明，彻底杜绝空白留白与文字挤压截断）。最后更新：2026-09-08 -->
					<div class="ac-picker-header-bar">
						<div class="ac-picker-tabs">
							<el-radio-group v-model="personTab" size="small" class="ac-segmented-group">
								<el-radio-button label="dept">
									<i class="el-icon-school"></i> 按部门
									<span class="scope-count-badge" v-if="selectedDeptCount">({{ selectedDeptCount }})</span>
								</el-radio-button>
								<el-radio-button label="student">
									<i class="el-icon-reading"></i> 学生
									<span class="scope-count-badge" v-if="studentSelect.length">({{ studentSelect.length }})</span>
								</el-radio-button>
								<el-radio-button label="teacher">
									<i class="el-icon-user"></i> 教职工
									<span class="scope-count-badge" v-if="teacherSelect.length">({{ teacherSelect.length }})</span>
								</el-radio-button>
							</el-radio-group>

							<!-- 紧邻 Tab 展示当前选中的班级/部门，消灭中间空白断层 -->
							<span v-if="personTab === 'student'" class="ac-current-dept-tag">
								<i class="el-icon-reading"></i>
								当前班级：<strong>{{ currentStudentDeptName || '请在左侧选择班级' }}</strong>
							</span>
							<span v-else-if="personTab === 'teacher'" class="ac-current-dept-tag">
								<i class="el-icon-office-building"></i>
								当前部门：<strong>{{ currentTeacherDeptName || '请在左侧选择部门' }}</strong>
							</span>
						</div>

						<!-- 右侧提示信息栏：拥有充足空间，文字完整舒展展示，不再截断 -->
						<div class="ac-picker-context-bar">
							<span v-if="personTab === 'dept'" class="ac-context-hint">
								<i class="el-icon-info"></i> 勾选父部门会自动包含当前所有子部门；下发天波时只发送末级部门，父部门无子部门时发送自身
							</span>
						</div>
					</div>

					<!-- 1. 按部门 Tab -->
					<div class="ac-picker-body ac-picker-body--dept" v-show="personTab === 'dept'" v-loading="deptTreeLoading">
						<div class="dept-scope-bar">
							<button
								type="button"
								class="dept-scope-btn"
								:class="{ 'is-active': deptDirectoryScope === 'teaching' }"
								@click="setDeptDirectoryScope('teaching')"
							>
								<i class="el-icon-reading"></i> 家校通讯录
								<span class="scope-count-badge" v-if="teachingDeptCheckedKeys.length">({{ teachingDeptCheckedKeys.length }})</span>
							</button>
							<button
								type="button"
								class="dept-scope-btn"
								:class="{ 'is-active': deptDirectoryScope === 'internal' }"
								@click="setDeptDirectoryScope('internal')"
							>
								<i class="el-icon-office-building"></i> 内部通讯录
								<span class="scope-count-badge" v-if="internalDeptCheckedKeys.length">({{ internalDeptCheckedKeys.length }})</span>
							</button>
						</div>

						<div class="ac-dept-panel-wrap">
							<!-- 家校部门树 -->
							<div v-show="deptDirectoryScope === 'teaching'" class="ac-dept-tree-panel">
								<div class="ac-tree-search-bar">
									<el-input
										placeholder="输入关键字搜索班级/部门..."
										v-model="teachingDeptFilterText"
										clearable
										size="small"
										prefix-icon="el-icon-search"
										class="tree-search-input">
									</el-input>
								</div>
								<div class="ac-tree-scroll">
									<el-tree
										ref="teachingDeptTree"
										:data="teachingDeptTree"
										node-key="value"
										show-checkbox
										:props="deptTreeProps"
										:default-expanded-keys="defaultExpandedTeachingKeys"
										:default-checked-keys="teachingDeptCheckedKeys"
										:filter-node-method="filterDeptNode"
										@check="onTeachingDeptCheck">
										<span class="tree-node tree-node--checkbox" slot-scope="{ node, data }">
											<span class="tree-node__dot" :class="'tone-' + nodeTone(data)"></span>
											<span class="tree-node__label" :title="node.label">{{ node.label }}</span>
										</span>
									</el-tree>
								</div>
							</div>

							<!-- 内部部门树 -->
							<div v-show="deptDirectoryScope === 'internal'" class="ac-dept-tree-panel">
								<div class="ac-tree-search-bar">
									<el-input
										placeholder="输入关键字搜索部门/教研组..."
										v-model="internalDeptFilterText"
										clearable
										size="small"
										prefix-icon="el-icon-search"
										class="tree-search-input">
									</el-input>
								</div>
								<div class="ac-tree-scroll">
									<el-tree
										ref="internalDeptTree"
										:data="internalDeptTree"
										node-key="value"
										show-checkbox
										:props="deptTreeProps"
										:default-expanded-keys="defaultExpandedInternalKeys"
										:default-checked-keys="internalDeptCheckedKeys"
										:filter-node-method="filterDeptNode"
										@check="onInternalDeptCheck">
										<span class="tree-node tree-node--checkbox" slot-scope="{ node, data }">
											<span class="tree-node__dot" :class="'tone-' + nodeTone(data)"></span>
											<span class="tree-node__label" :title="node.label">{{ node.label }}</span>
										</span>
									</el-tree>
								</div>
							</div>
						</div>
					</div>

					<!-- 2. 学生 Tab：按范围选 / 已选列表切换。最后更新：2026-10-29 -->
					<div class="ac-picker-body ac-picker-body--ps" v-show="personTab === 'student'">
						<div class="ps-layout ac-ps-layout" :class="{ 'is-selected-view': studentViewMode === 'selected' }">
							<div class="ps-left" v-show="studentViewMode === 'pick'" v-loading="deptTreeLoading">
								<div class="ps-left-header">
									<i class="el-icon-office-building"></i>
									<span>选择机构 / 学校</span>
								</div>
								<div class="ps-scope-fixed">
									<i class="el-icon-reading"></i> 家校通讯录
								</div>
								<div class="ps-left-search">
									<el-input
										v-model="studentDeptFilterText"
										clearable
										size="small"
										prefix-icon="el-icon-search"
										placeholder="输入关键字搜索机构/学校..."
									/>
								</div>
								<div class="ps-left-tree">
									<el-tree
										ref="studentDeptTree"
										:data="teachingDeptTree"
										node-key="value"
										:props="deptTreeProps"
										highlight-current
										:default-expanded-keys="defaultExpandedTeachingKeys"
										:expand-on-click-node="false"
										:filter-node-method="filterDeptNode"
										@node-click="handleStudentDeptClick"
									>
										<span class="ps-tree-node" slot-scope="{ node, data }">
											<span class="ps-tree-node__dot" :class="'tone-' + nodeTone(data)"></span>
											<span class="ps-tree-node__label" :title="node.label">{{ node.label }}</span>
										</span>
									</el-tree>
								</div>
							</div>

							<div class="ps-right" v-loading="studentViewMode === 'pick' && studentCandidatesLoading">
								<div class="ps-meta ac-student-meta">
									<div class="ac-student-meta__left">
										原已选：<strong>{{ personBaselineStudentIds.length }}</strong> 人
										<template v-if="studentPickDelta.added || studentPickDelta.removed">
											<span class="ps-meta-sep">·</span>
											<span v-if="studentPickDelta.added" class="ps-delta ps-delta--add">新增 {{ studentPickDelta.added }}</span>
											<span v-if="studentPickDelta.removed" class="ps-delta ps-delta--del">删除 {{ studentPickDelta.removed }}</span>
											<span class="ps-meta-sep">·</span>
											确认后 <strong>{{ studentSelect.length }}</strong> 人
										</template>
										<template v-else>
											<span class="ps-meta-sep">·</span>
											本次无变更
										</template>
										<span class="ps-meta-sep">·</span>
										跨班勾选自动保留，确认后生效
									</div>
									<el-radio-group v-model="studentViewMode" size="mini" class="ac-student-view-mode" @change="onStudentViewModeChange">
										<el-radio-button label="pick">按范围选</el-radio-button>
										<el-radio-button label="selected">已选 {{ studentSelect.length }}</el-radio-button>
									</el-radio-group>
								</div>

								<!-- 按范围选人 -->
								<template v-if="studentViewMode === 'pick'">
									<div class="ps-filter-bar">
										<el-input
											v-model="studentSearchName"
											clearable
											size="small"
											prefix-icon="el-icon-search"
											placeholder="姓名"
											class="ps-name-input"
											:disabled="!currentStudentDeptId"
											@keyup.enter.native="handleStudentSearch"
											@clear="handleStudentSearch"
										/>
										<el-select
											v-model="studentFilterLiveType"
											size="small"
											clearable
											placeholder="人员类型"
											class="ac-ps-filter-select"
											:disabled="!currentStudentDeptId"
											@change="onStudentQuickFilterChange"
											@clear="onStudentQuickFilterChange"
										>
											<el-option
												v-for="chip in studentLiveTypeChips"
												:key="'lt-' + chip.name"
												:label="chip.name + '（' + chip.count + '）'"
												:value="chip.name"
											/>
										</el-select>
										<el-select
											v-if="studentTagOptions.length"
											v-model="studentFilterTagId"
											size="small"
											clearable
											filterable
											placeholder="学生标签（含非放学）"
											class="ac-ps-filter-select ac-ps-filter-select--tag"
											:disabled="!currentStudentDeptId"
											@change="onStudentQuickFilterChange"
											@clear="onStudentQuickFilterChange"
										>
											<el-option
												v-for="tag in studentTagOptions"
												:key="'tag-' + tag.id"
												:label="(tag.applyToDismissal ? '' : '【非放学】') + tag.categoryName + '：' + tag.tagName + '（' + studentTagCount(tag.id) + '）'"
												:value="tag.id"
											/>
										</el-select>
										<el-button type="primary" size="small" :disabled="!currentStudentDeptId" @click="handleStudentSearch">查询</el-button>
										<el-button size="small" :disabled="!currentStudentDeptId || !studentFilteredRows.length" @click="selectAllCurrentStudentDept">全选当前</el-button>
										<el-button size="small" :disabled="!currentStudentDeptId" @click="clearCurrentStudentDept">清空当前</el-button>
										<el-button size="small" type="text" class="ac-ps-clear-all" :disabled="!studentSelect.length" @click="clearAllSelectedStudents">清空全部已选</el-button>
									</div>

									<div v-if="currentStudentDeptId" class="ps-hint">
										当前范围：<strong>{{ currentStudentDeptName }}</strong>
										<span class="ps-hint-sub">（共 {{ studentFilteredRows.length }} 人 · {{ studentQuickFilterHint }}）</span>
									</div>
									<div v-else class="ps-hint ps-hint--warn">请先在左侧选择班级 / 年级</div>

									<div class="ps-table-wrap" ref="studentTableWrap">
										<el-table
											ref="studentPeopleTable"
											:data="studentPagedRows"
											row-key="Id"
											size="small"
											stripe
											:height="studentTableHeight"
											@row-click="onStudentRowClick"
											@selection-change="onStudentTableSelectionChange"
										>
											<el-table-column type="selection" width="46" align="center" />
											<el-table-column prop="Name" label="姓名" min-width="110" show-overflow-tooltip />
											<el-table-column label="人员类型" min-width="110" align="center" show-overflow-tooltip>
												<template slot-scope="scope">
													<span v-if="scope.row.LiveType" class="ac-student-tag" :class="studentLiveTypeClass(scope.row.LiveType)">
														{{ scope.row.LiveType }}
													</span>
													<span v-else class="ps-avatar-empty">—</span>
												</template>
											</el-table-column>
											<el-table-column label="学生标签" min-width="140" show-overflow-tooltip>
												<template slot-scope="scope">
													<span v-if="scope.row.StudentTags && scope.row.StudentTags.length">
														{{ (scope.row.StudentTags || []).map(t => t.tagName).join('、') }}
													</span>
													<span v-else class="ps-avatar-empty">未设置</span>
												</template>
											</el-table-column>
											<el-table-column prop="DepartmentName" label="部门" min-width="140" show-overflow-tooltip />
											<el-table-column label="头像" width="72" align="center" header-align="center">
												<template slot-scope="scope">
													<oss-media-thumbs
														v-if="scope.row.HeadPhotoImage"
														:media="scope.row.HeadPhotoImage"
														thumb-width="40px"
														thumb-height="40px"
													/>
													<span v-else class="ps-avatar-empty">无</span>
												</template>
											</el-table-column>
										</el-table>
									</div>

									<div class="ps-pager-wrap">
										<el-pagination
											layout="total, prev, pager, next"
											:page-size="studentTablePageSize"
											:total="studentFilteredRows.length"
											:current-page="studentTablePage"
											@current-change="onStudentTablePageChange"
										/>
									</div>
								</template>

								<!-- 已选列表：独立 selectedViewRows 灌数，避免 map 计算属性丢字段。最后更新：2026-10-29 -->
								<template v-else>
									<div class="ps-filter-bar">
										<el-input
											v-model="selectedStudentSearchName"
											clearable
											size="small"
											prefix-icon="el-icon-search"
											placeholder="在已选中搜索姓名"
											class="ps-name-input"
											@input="selectedStudentTablePage = 1"
										/>
										<el-button size="small" type="text" class="ac-ps-clear-all" :disabled="!studentSelect.length" @click="clearAllSelectedStudents">清空全部已选</el-button>
									</div>
									<div class="ps-hint">
										共已选 <strong>{{ studentSelect.length }}</strong> 人
										<span class="ps-hint-sub">（可在此移除；切回「按范围选」继续勾选）</span>
										<span v-if="selectedViewLoading" class="ps-hint-sub"> · 正在加载详情…</span>
									</div>
									<div class="ps-table-wrap" ref="studentSelectedTableWrap" v-loading="selectedViewLoading">
										<el-table
											:key="'sel-view-' + selectedViewRows.length + '-' + selectedStudentTablePage"
											:data="selectedViewPagedRows"
											:row-key="row => String(row.Id)"
											size="small"
											stripe
											:height="studentTableHeight"
										>
											<el-table-column prop="displayName" label="姓名" min-width="120" show-overflow-tooltip />
											<el-table-column label="人员类型" min-width="110" align="center" show-overflow-tooltip>
												<template slot-scope="scope">
													<span v-if="scope.row.LiveType" class="ac-student-tag" :class="studentLiveTypeClass(scope.row.LiveType)">
														{{ scope.row.LiveType }}
													</span>
													<span v-else class="ps-avatar-empty">—</span>
												</template>
											</el-table-column>
											<el-table-column label="学生标签" min-width="140" show-overflow-tooltip>
												<template slot-scope="scope">
													<span v-if="scope.row.StudentTags && scope.row.StudentTags.length">
														{{ (scope.row.StudentTags || []).map(t => t.tagName).join('、') }}
													</span>
													<span v-else class="ps-avatar-empty">未设置</span>
												</template>
											</el-table-column>
											<el-table-column prop="DepartmentName" label="部门" min-width="140" show-overflow-tooltip />
											<el-table-column label="头像" width="72" align="center" header-align="center">
												<template slot-scope="scope">
													<oss-media-thumbs
														v-if="scope.row.HeadPhotoImage"
														:media="scope.row.HeadPhotoImage"
														thumb-width="40px"
														thumb-height="40px"
													/>
													<span v-else class="ps-avatar-empty">无</span>
												</template>
											</el-table-column>
											<el-table-column label="操作" width="80" align="center" fixed="right">
												<template slot-scope="scope">
													<el-button type="text" size="mini" class="ac-ps-remove-btn" @click="removeSelectedStudent(scope.row.Id)">移除</el-button>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="ps-pager-wrap">
										<el-pagination
											layout="total, prev, pager, next"
											:page-size="studentTablePageSize"
											:total="selectedViewFilteredRows.length"
											:current-page="selectedStudentTablePage"
											@current-change="onSelectedStudentTablePageChange"
										/>
									</div>
								</template>
							</div>
						</div>
					</div>

					<!-- 3. 教职工 Tab -->
					<div class="ac-picker-body ac-picker-body--split" v-show="personTab === 'teacher'">
						<div class="ac-picker-tree ac-person-picker-tree" v-loading="deptTreeLoading">
							<div class="ac-tree-header-tag">
								<i class="el-icon-office-building"></i> 内部架构(选择部门)
							</div>
							<div class="ac-tree-search-bar ac-tree-search-bar--compact">
								<el-input
									placeholder="搜索行政部门/科室..."
									v-model="teacherDeptFilterText"
									clearable
									size="mini"
									prefix-icon="el-icon-search"
									class="tree-search-input">
								</el-input>
							</div>
							<div class="ac-tree-scroll ac-tree-scroll--narrow">
								<el-tree
									ref="teacherDeptTree"
									:data="internalDeptTree"
									node-key="value"
									:props="deptTreeProps"
									highlight-current
									:default-expanded-keys="defaultExpandedInternalKeys"
									:expand-on-click-node="false"
									:filter-node-method="filterDeptNode"
									@node-click="handleTeacherDeptClick">
									<span class="tree-node" slot-scope="{ node, data }">
										<span class="tree-node__dot" :class="'tone-' + nodeTone(data)"></span>
										<span class="tree-node__label" :title="node.label">{{ node.label }}</span>
										<i class="el-icon-arrow-right tree-node__arrow"></i>
									</span>
								</el-tree>
							</div>
						</div>

						<div class="ac-picker-transfer" v-loading="teacherCandidatesLoading">
							<div class="ac-transfer-top-bar">
								<div class="ac-transfer-top-left">
									<span class="ac-transfer-panel-title">
										<i class="el-icon-user"></i> 教职工穿梭选择
									</span>
									<span class="ac-transfer-retain-tag">
										原已选 {{ personBaselineTeacherIds.length }}
										<template v-if="teacherPickDelta.added || teacherPickDelta.removed">
											· <span v-if="teacherPickDelta.added" class="ps-delta ps-delta--add">新增 {{ teacherPickDelta.added }}</span>
											<span v-if="teacherPickDelta.removed" class="ps-delta ps-delta--del">删除 {{ teacherPickDelta.removed }}</span>
											· 确认后 {{ teacherSelect.length }}
										</template>
										<template v-else> · 本次无变更</template>
									</span>
								</div>
								<div class="ac-transfer-search-name" v-if="currentTeacherDeptId">
									<el-input
										size="mini"
										clearable
										placeholder="教师姓名搜索并回车"
										v-model="teacherSearchName"
										@keyup.enter.native="handleTeacherSearch"
										@clear="handleTeacherSearch">
										<el-button slot="append" icon="el-icon-search" @click="handleTeacherSearch"></el-button>
									</el-input>
								</div>
							</div>
							<el-transfer
								class="ac-transfer"
								filterable
								filter-placeholder="列表内筛选姓名"
								:titles="['未选教职工', '已选教职工']"
								v-model="teacherSelect"
								:data="transferTeacherData"
								:props="{ label: 'Name', key: 'Id' }"
								@change="handleTeacherTransferChange">
							</el-transfer>
						</div>
					</div>
				</div>

				<!-- 底部统计与操作按钮：左侧汇总统计，右侧操作确认。最后更新：2026-09-08 -->
				<div slot="footer" class="ac-person-dialog-footer">
					<div class="ac-picker-status-tip">
						<i class="el-icon-info"></i>
						<span>
							原已选：部门 <strong>{{ personBaselineDeptCount }}</strong>
							｜ 学生 <strong>{{ personBaselineStudentIds.length }}</strong>
							｜ 教职工 <strong>{{ personBaselineTeacherIds.length }}</strong>
							<span v-if="personPickHasDelta">
								；本次
								<template v-if="deptPickDelta.added || deptPickDelta.removed">
									部门
									<span v-if="deptPickDelta.added" class="ps-delta ps-delta--add">+{{ deptPickDelta.added }}</span>
									<span v-if="deptPickDelta.removed" class="ps-delta ps-delta--del">-{{ deptPickDelta.removed }}</span>
								</template>
								<template v-if="studentPickDelta.added || studentPickDelta.removed">
									学生
									<span v-if="studentPickDelta.added" class="ps-delta ps-delta--add">+{{ studentPickDelta.added }}</span>
									<span v-if="studentPickDelta.removed" class="ps-delta ps-delta--del">-{{ studentPickDelta.removed }}</span>
								</template>
								<template v-if="teacherPickDelta.added || teacherPickDelta.removed">
									教职工
									<span v-if="teacherPickDelta.added" class="ps-delta ps-delta--add">+{{ teacherPickDelta.added }}</span>
									<span v-if="teacherPickDelta.removed" class="ps-delta ps-delta--del">-{{ teacherPickDelta.removed }}</span>
								</template>
							</span>
							<span v-else>；本次无变更</span>
							；确认后：部门 <strong>{{ selectedDeptCount }}</strong>
							｜ 学生 <strong>{{ studentSelect.length }}</strong>
							｜ 教职工 <strong>{{ teacherSelect.length }}</strong>
						</span>
					</div>
					<div class="ac-person-footer-btns">
						<el-button @click="cancelPersonPicker">取消</el-button>
						<el-button type="primary" @click="confirmAPerson" :disabled="deptTreeLoading" :loading="deptTreeLoading">确认生效</el-button>
					</div>
				</div>
			</el-dialog>
			<!-- 设备添加弹窗。直接列出当前学校名下所有门禁设备，移除无意义部门树。最后更新：2026-09-14 -->
			<el-dialog :title="deviceAddTitle" :visible.sync="deviceVisible"
				:close-on-click-modal="false" width="960px" custom-class="ac-picker-dialog ac-device-dialog">
				<div class="ac-device-transfer-body" v-loading="deviceLoading">
					<el-transfer
						class="ac-transfer ac-device-transfer"
						filterable
						filter-placeholder="输入设备名称筛选"
						:titles="['未选设备', '已选设备']"
						v-model="deviceSelect"
						:data="deviceList"
						:props="{ label: 'TerminalName', key: 'KqTerminalId' }">
					</el-transfer>
					<div class="ac-transfer-bottom-tip" style="margin-top: 10px; text-align: right;">
						<span>已选设备共 <strong>{{ deviceSelect.length }}</strong> 台</span>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="deviceVisible = false">取消</el-button>
					<el-button type="primary" @click="confirmDevices">确认</el-button>
				</div>
			</el-dialog>
			<!-- 规则添加弹窗。最后更新：2026-09-08 -->
			<el-dialog title="门禁规则" :visible.sync="ruleVisible" :close-on-click-modal="false">
				<el-form ref="ruleForm" :model="ruleParam" :rules="ruleRules" label-width="80px" v-if="ruleVisible">
					<el-form-item label="类型" prop="type">
						<el-radio-group v-model="ruleParam.type">
							<el-radio-button :label="ruleParam.type">{{
								ruleParam.type == 2 ? '入门禁' : '出门禁'
							}}</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="时段" prop="timePeriod">
						<el-time-picker is-range v-model="ruleParam.timePeriod" :picker-options="{ format: 'HH:mm' }"
							start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
						</el-time-picker>
					</el-form-item>
					<el-form-item label="人员类型" prop="userRole">
						<el-checkbox-group v-model="ruleParam.userRole">
							<el-checkbox :label="item.value" border v-for="(item, index) in userRoles" :key="index">
								<span>{{ item.baseName }}</span>
								<span v-if="item.alias" class="ac-role-alias">{{ item.alias }}</span>
							</el-checkbox>
						</el-checkbox-group>
						<div class="ac-role-alias-hint" v-if="hasUserRoleAlias">灰色为部门配置中的本校别名，下发天波仍按固定类型</div>
					</el-form-item>
					<el-form-item label="性别">
						<el-radio-group v-model="ruleParam.sex">
							<el-radio-button :label="0">不限</el-radio-button>
							<el-radio-button :label="1">男</el-radio-button>
							<el-radio-button :label="2">女</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<!-- <el-form-item label="年级">
						<el-select v-model="ruleParam.grade" multiple placeholder="请选择">
							<el-option v-for="item in grades" :key="item.Id" :label="item.Name" :value="item.Id">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="周期" prop="weekNo">
						<el-select v-model="ruleParam.weekNo" multiple placeholder="请选择">
							<el-option v-for="item in weekNos" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="通行状态">
						<el-radio-group v-model="ruleParam.passStatus">
							<el-radio-button :label="1">允许通行</el-radio-button>
							<el-radio-button :label="2">禁止通行</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="ruleVisible = false">取消</el-button>
					<el-button type="primary" @click="confirmRule">确认</el-button>
				</div>
			</el-dialog>
			<!-- 列表设备查看弹窗。最后更新：2026-09-08 -->
			<el-dialog :title="viewDeviceDialog.title" :visible.sync="viewDeviceDialog.visible" width="640px"
				:close-on-click-modal="false" custom-class="ac-device-view-dialog">
				<div class="ac-device-view-header">
					<div class="ac-device-view-info">
						<span class="ac-device-view-info-item">
							<span class="info-label">规则：</span>
							<span class="info-val">{{ viewDeviceDialog.ruleName }}</span>
						</span>
						<span class="ac-device-view-info-item">
							<span class="info-label">场所：</span>
							<span class="info-val">{{ viewDeviceDialog.place }}</span>
						</span>
						<span class="ac-device-view-info-item">
							<span class="info-label">总数：</span>
							<el-tag size="mini" type="primary" effect="plain">{{ (viewDeviceDialog.devices || []).length }} 台</el-tag>
						</span>
					</div>
					<div class="ac-device-view-toolbar">
						<el-input v-model="viewDeviceDialog.filterKey" size="small" placeholder="搜索设备SN..."
							prefix-icon="el-icon-search" clearable style="width: 220px;">
						</el-input>
						<el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllDeviceSns">
							复制全部SN
						</el-button>
					</div>
				</div>
				<div class="ac-device-view-body">
					<el-table :data="filteredViewDevices" border stripe size="small" max-height="360" empty-text="未找到匹配设备">
						<el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
						<el-table-column prop="sn" label="设备序列号 (SN)">
							<template slot-scope="scope">
								<span class="ac-device-sn-code">{{ scope.row.sn }}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="90" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="mini" icon="el-icon-copy-document" @click="copySingleSn(scope.row.sn)">复制</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="viewDeviceDialog.visible = false">关闭</el-button>
				</div>
			</el-dialog>
		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { testapi } from '../../api/modules/auth';
import {
	getAccessControlRuleListPage,
	deleteAccessControlRule,
	editAccessControlRule,
	addAccessControlRule,
	getAccessControlPersonsByIds,
	getAccessTempRuleListPage,
	saveAccessTempRule,
	deleteAccessTempRule,
	pushAccessTempRuleNow,
	finishAccessTempRuleNow,
} from '../../api/modules/misc';
import {
	getSubDepartmentTree,
	getTeachingDepartmentTree,
	getInternalDepartmentTree,
} from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getDeviveList } from '../../api/modules/attendance';
import { setAccessEnabled, batchSwitch, createOrUpdateBackup, getSchoolSchemeProfile, saveSchoolSchemeProfile } from '../../api/modules/scheme-switch'
import { getStudentSelectList, getTeacherMasterListPage } from '../../api/modules/personnel';
import { fetchAndMapStudentTags } from '@/utils/studentScopeTags';
import { fetchStudentLiveTypesByDeptId } from '../../utils/studentLiveType'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
import { normalizeDeptId, deptIdsEqual, treeNodeDeptId, toDeptId } from '../../utils/deptCascaderProps'
import {
	lockPersonScopeSelectionSync,
	syncPersonScopeElTableSelection,
} from '../../utils/personScopeTableSelection'

/** 门禁人员类型与 LiveTypeId 对应（下发天波用 0/1/2，与展示名无关）。创建于 2026-10-16 */
const ACCESS_USER_ROLE_BASE = [
	{ value: 0, baseName: '学生(走读)', liveTypeId: 'live_home' },
	{ value: 1, baseName: '学生(住宿)', liveTypeId: 'live_school' },
	{ value: 2, baseName: '学生(半走读)', liveTypeId: 'live_home_spe' },
	{ value: 3, baseName: '教师' },
]

export default {
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			currentDepartmentName: '',
			filters: {},
			BaseApiUrl: BaseApiUrl, //网络前缀
			searchList: [
				{
					label: '规则名称',
					key: 'name',
				},
			],
			multipleSelection: [],
			users: [],
			total: 0,
			buttonList: [],
			schemeBusy: false,
			schemeSlot1Name: '方案一',
			schemeSlot2Name: '方案二',
			schoolSchemeSlot: 1,
			schemeHasBackup: false,
			switchSchemeDialogVisible: false,
			switchTargetSlot: 1,
			page: 1,
			listLoading: false,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			suppressPassStatusWarn: false, // 打开编辑回填时抑制「允许通行」危险弹窗
			editLoading: false,
			FormRules: {
				RuleName: [
					{ required: true, message: '请输入规则名称', trigger: 'blur' },
				],
				Place: [{ required: true, message: '请输入生效场所', trigger: 'blur' }],
			},
			//编辑界面数据
			editForm: null,
			isResouceShow: 0,
			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			//新增界面数据
			addForm: null,
			DepartmentId: 0,
			// 人员选择弹窗状态（重构为【按部门】、【学生】、【教职工】三大独立 Tab）。最后更新：2026-09-08
			personVisible: false,
			/** 每次打开选人弹窗递增，配合 destroy-on-close 强制重建部门树，避免上次勾选残留。最后更新：2026-10-29 */
			personPickerEpoch: 0,
			personTab: 'dept', // 当前激活的 Tab: 'dept' 按部门，'student' 学生，'teacher' 教职工
			deptDirectoryScope: 'teaching', // 部门模式下：'teaching' 家校通讯录，'internal' 内部通讯录
			deptTreeLoading: false,
			teachingDeptTree: [],
			internalDeptTree: [],
			teachingDeptFilterText: '',
			internalDeptFilterText: '',
			teachingDeptCheckedKeys: [],
			internalDeptCheckedKeys: [],
			pendingEchoDeptIds: [], // 待回显的全部部门 ID，待树加载完毕后精准分流到两棵树
			deptTreeProps: {
				children: 'children',
				label: 'label',
			},

			// 学生 Tab 状态
			studentDeptFilterText: '',
			currentStudentDeptId: 0,
			currentStudentDeptName: '',
			currentStudentDeptOrgType: '',
			currentStudentCampusId: '',
			studentSearchName: '',
			studentCandidatesLoading: false,
			candidateStudents: [],
			selectedStudentsMap: {},
			studentSelect: [],
			/** 人员类型快捷筛选（空=全部） */
			studentFilterLiveType: '',
			/** 学生标签快捷筛选（空=全部） */
			studentFilterTagId: null,
			/** 本校区学生标签选项（含放学/档案，用于筛选下拉） */
			studentTagOptions: [],
			studentTablePage: 1,
			studentTablePageSize: 10,
			studentTableHeight: 320,
			_studentTableSyncing: false,
			/** 学生右侧：按范围选 | 已选列表。最后更新：2026-10-29 */
			studentViewMode: 'pick',
			selectedStudentSearchName: '',
			selectedStudentTablePage: 1,
			/** 已选视图专用行数据（与 map 解耦，切换时强制重建）。最后更新：2026-10-29 */
			selectedViewRows: [],
			selectedViewLoading: false,

			/** 打开选人弹窗时的底稿（取消还原；确认才写入表单）。最后更新：2026-10-29 */
			personBaselineStudentIds: [],
			personBaselineTeacherIds: [],
			personBaselineTeachingKeys: [],
			personBaselineInternalKeys: [],
			personBaselineStudentsMap: {},
			personBaselineTeachersMap: {},
			_personPickerConfirmed: false,

			// 教职工 Tab 状态
			teacherDeptFilterText: '',
			currentTeacherDeptId: 0,
			currentTeacherDeptName: '',
			teacherSearchName: '',
			teacherCandidatesLoading: false,
			candidateTeachers: [],
			selectedTeachersMap: {},
			teacherSelect: [],

			departments: null,
			departmentSelect: [],
			userSelect: [],
			userList: [],

			// 设备选择
			deviceAddTitle: '选择设备',
			deviceVisible: false,
			deviceLoading: false,
			deviceSelect: [],
			deviceList: [],

			// 添加规则
			ruleVisible: false,
			ruleParam: {},
			ruleRules: {
				type: [{ required: true, message: '', trigger: 'blur' }],
				timePeriod: [{ required: true, message: '选择时段', trigger: 'blur' }],
				userRole: [
					{ required: true, message: '请选择人员类型', trigger: 'blur' },
				],
				weekNo: [{ required: true, message: '请选择周期', trigger: 'blur' }],
			},
			/** 人员类型选项；name 含本校别名，供列表标签；alias 供勾选框灰色副标。最后更新：2026-10-16 */
			userRoles: ACCESS_USER_ROLE_BASE.map((item) => ({
				...item,
				alias: '',
				name: item.baseName,
			})),
			grades: [
				{
					Id: '1',
					Name: '一年级',
				},
				{
					Id: '2',
					Name: '二年级',
				},
			],
			weekNos: [
				{
					label: '周一',
					value: 1,
				},
				{
					label: '周二',
					value: 2,
				},
				{
					label: '周三',
					value: 3,
				},
				{
					label: '周四',
					value: 4,
				},
				{
					label: '周五',
					value: 5,
				},
				{
					label: '周六',
					value: 6,
				},
				{
					label: '周日',
					value: 7,
				},
			],

			// 临时规则 Tab。创建于 2026-10-12
			activeTab: 'daily',
			tempRules: [],
			tempTotal: 0,
			tempPage: 1,
			tempLoading: false,
			tempFilters: { title: '', status: '' },
			tempFormVisible: false,
			tempSaving: false,
			tempForm: null,
			tempFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				Place: [{ required: true, message: '请输入生效场所', trigger: 'blur' }],
				PushAt: [{ required: true, message: '请选择下发时间', trigger: 'change' }],
				DeleteAt: [{ required: true, message: '请选择删除时间', trigger: 'change' }],
			},
			tempReasonOptions: [
				{ value: 'Holiday', label: '节假日' },
				{ value: 'Activity', label: '学校活动' },
				{ value: 'Other', label: '其他' },
			],
			tempStatusOptions: [
				{ value: 'PendingPush', label: '待下发', type: 'warning' },
				{ value: 'Pushing', label: '下发中', type: '' },
				{ value: 'ActiveOnTb', label: '已在天波', type: 'success' },
				{ value: 'Deleting', label: '删除中', type: '' },
				{ value: 'Finished', label: '已结束', type: 'info' },
				{ value: 'Failed', label: '失败', type: 'danger' },
			],
			tempCopySourceId: null,
			dailyRuleOptions: [],
			dailyRuleOptionsLoading: false,
			tempDirections: [
				{ type: 1, label: '出', icon: 'el-icon-right', deviceKey: 'OutDeviceSns' },
				{ type: 2, label: '入', icon: 'el-icon-back', deviceKey: 'InDeviceSns' },
			],

			// 查看列表设备弹窗。最后更新：2026-09-08
			viewDeviceDialog: {
				visible: false,
				title: '查看设备',
				deviceType: 'out', // 'out' 出设备，'in' 入设备
				ruleName: '',
				place: '',
				devices: [],
				filterKey: '',
			},
		}
	},
	computed: {
		/**
		 * 过滤后的查看设备列表。最后更新：2026-09-08
		 */
		filteredViewDevices() {
			const list = this.viewDeviceDialog.devices || []
			const key = (this.viewDeviceDialog.filterKey || '').trim().toLowerCase()
			if (!key) {
				return list.map((sn) => ({ sn }))
			}
			return list
				.filter((sn) => String(sn).toLowerCase().includes(key))
				.map((sn) => ({ sn }))
		},
		userRoleMap() {
			let map = new Map()
			this.userRoles.forEach((item) => {
				map.set(item.value, item.name)
			})
			return map
		},
		/** 是否存在本校人员类型别名（用于提示文案）。创建于 2026-10-16 */
		hasUserRoleAlias() {
			return (this.userRoles || []).some((item) => !!(item && item.alias))
		},
		weekNoMap() {
			let map = new Map()
			this.weekNos.forEach((item) => {
				map.set(item.value, item.label)
			})
			return map
		},
		/**
		 * 部门树默认展开首个根节点 Key（无需全部展开，默认仅展开首个节点）。创建于 2026-09-08
		 */
		defaultExpandedTeachingKeys() {
			if (this.teachingDeptTree && this.teachingDeptTree.length > 0) {
				const first = this.teachingDeptTree[0]
				return [first.value || first.Id]
			}
			return []
		},
		defaultExpandedInternalKeys() {
			if (this.internalDeptTree && this.internalDeptTree.length > 0) {
				const first = this.internalDeptTree[0]
				return [first.value || first.Id]
			}
			return []
		},
		/**
		 * 已选部门去重总数
		 */
		selectedDeptCount() {
			const set = new Set([
				...(this.teachingDeptCheckedKeys || []),
				...(this.internalDeptCheckedKeys || []),
			])
			return set.size
		},
		personBaselineDeptCount() {
			const set = new Set([
				...(this.personBaselineTeachingKeys || []),
				...(this.personBaselineInternalKeys || []),
			])
			return set.size
		},
		/** 相对打开底稿的增减。最后更新：2026-10-29 */
		studentPickDelta() {
			return this.diffIdSets(this.studentSelect, this.personBaselineStudentIds, 'person')
		},
		teacherPickDelta() {
			return this.diffIdSets(this.teacherSelect, this.personBaselineTeacherIds, 'person')
		},
		deptPickDelta() {
			const current = [
				...(this.teachingDeptCheckedKeys || []),
				...(this.internalDeptCheckedKeys || []),
			]
			const baseline = [
				...(this.personBaselineTeachingKeys || []),
				...(this.personBaselineInternalKeys || []),
			]
			return this.diffIdSets(current, baseline, 'dept')
		},
		personPickHasDelta() {
			const s = this.studentPickDelta
			const t = this.teacherPickDelta
			const d = this.deptPickDelta
			return !!(s.added || s.removed || t.added || t.removed || d.added || d.removed)
		},
		// 出入门禁规则与设备计算属性，避免方法调用导致的不必要重新渲染。创建于 2026-09-08
		editFormOutRules() {
			return ((this.editForm && this.editForm.SubRules) || []).filter((r) => r.type == 1)
		},
		editFormInRules() {
			return ((this.editForm && this.editForm.SubRules) || []).filter((r) => r.type == 2)
		},
		addFormOutRules() {
			return ((this.addForm && this.addForm.SubRules) || []).filter((r) => r.type == 1)
		},
		addFormInRules() {
			return ((this.addForm && this.addForm.SubRules) || []).filter((r) => r.type == 2)
		},
		/** 当前班候选里各人员类型人数。最后更新：2026-10-29 */
		studentLiveTypeChips() {
			const map = {};
			(this.candidateStudents || []).forEach((s) => {
				const name = (s.LiveType || '').trim() || '未设置';
				map[name] = (map[name] || 0) + 1;
			});
			return Object.keys(map)
				.sort((a, b) => map[b] - map[a])
				.map((name) => ({ name, count: map[name] }));
		},
		/** 当前部门列表（已应用类型/标签筛选）。最后更新：2026-10-29 */
		studentFilteredRows() {
			return (this.candidateStudents || []).filter((s) => this.studentMatchesQuickFilter(s));
		},
		studentPagedRows() {
			const rows = this.studentFilteredRows || [];
			const size = this.studentTablePageSize || 10;
			const page = this.studentTablePage || 1;
			const start = (page - 1) * size;
			return rows.slice(start, start + size);
		},
		/** 已选视图：本地搜索。最后更新：2026-10-29 */
		selectedViewFilteredRows() {
			const q = (this.selectedStudentSearchName || '').trim().toLowerCase()
			const list = this.selectedViewRows || []
			if (!q) return list
			return list.filter((s) => String(s.displayName || '').toLowerCase().indexOf(q) > -1)
		},
		selectedViewPagedRows() {
			const rows = this.selectedViewFilteredRows || []
			const size = this.studentTablePageSize || 10
			const page = this.selectedStudentTablePage || 1
			const start = (page - 1) * size
			return rows.slice(start, start + size)
		},
		studentQuickFilterHint() {
			const parts = [];
			if (this.studentFilterLiveType) parts.push(this.studentFilterLiveType);
			if (this.studentFilterTagId) {
				const t = (this.studentTagOptions || []).find((x) => String(x.id) === String(this.studentFilterTagId));
				if (t) parts.push(`${t.categoryName}：${t.tagName}`);
			}
			if (!parts.length) return '未筛选';
			return `筛选：${parts.join(' · ')}`;
		},
		/**
		 * 教职工穿梭框数据源：当前候选教师 + 已选教师（去重）。
		 * 纯净姓名，无任何后缀，彻底杜绝几千 DOM 节点卡顿。创建于 2026-09-08
		 */
		transferTeacherData() {
			const map = new Map();
			(this.candidateTeachers || []).forEach((item) => {
				if (item && item.Id) map.set(Number(item.Id), item);
			});
			(this.teacherSelect || []).forEach((id) => {
				const numId = Number(id);
				if (!map.has(numId)) {
					const cached = this.selectedTeachersMap[numId];
					if (cached) {
						map.set(numId, cached);
					} else {
						map.set(numId, { Id: numId, Name: `教师(${numId})` });
					}
				}
			});
			return Array.from(map.values());
		},
		/**
		 * 临时规则编辑权限：菜单权限中配置隐藏按钮 Func=accessTempRuleEdit。创建于 2026-10-12
		 */
		canEditTempRule() {
			return (this.buttonList || []).some((b) => b.Func === 'accessTempRuleEdit')
		},
		/**
		 * 临时规则查看权限：Func=accessTempRuleView，有编辑权限也可查看。创建于 2026-10-12
		 */
		canViewTempRule() {
			return this.canEditTempRule || (this.buttonList || []).some((b) => b.Func === 'accessTempRuleView')
		},
		activeSchemeName() {
			return this.schoolSchemeSlot === 2 ? this.schemeSlot2Name : this.schemeSlot1Name
		},
		inactiveSchemeName() {
			return this.schoolSchemeSlot === 2 ? this.schemeSlot1Name : this.schemeSlot2Name
		},
	},
	watch: {
		teachingDeptFilterText(val) {
			if (this.$refs.teachingDeptTree) {
				this.$refs.teachingDeptTree.filter(val);
			}
		},
		internalDeptFilterText(val) {
			if (this.$refs.internalDeptTree) {
				this.$refs.internalDeptTree.filter(val);
			}
		},
		studentDeptFilterText(val) {
			if (this.$refs.studentDeptTree) {
				this.$refs.studentDeptTree.filter(val);
			}
		},
		teacherDeptFilterText(val) {
			if (this.$refs.teacherDeptTree) {
				this.$refs.teacherDeptTree.filter(val);
			}
		},
		personVisible(val) {
			if (val) {
				this._personPickerConfirmed = false
				this.$nextTick(() => this.updateStudentTableHeight())
				return
			}
			// 点遮罩/关闭按钮未确认时，还原底稿，避免半成品写回表单外状态
			if (!this._personPickerConfirmed) {
				this.restorePersonBaseline()
			}
			this._personPickerConfirmed = false
		},
		personTab(val) {
			if (val === 'student') {
				this.$nextTick(() => {
					this.autoSelectDefaultStudentDept()
					this.updateStudentTableHeight()
					if (this.studentViewMode === 'selected') this.loadSelectedViewRows()
				})
			}
		},
		studentViewMode(val) {
			if (val === 'selected') {
				this.selectedStudentTablePage = 1
				this.loadSelectedViewRows()
			}
		},
	},
	methods: {
		/**
		 * 门禁启用/禁用（同步天波）。创建于 2026-09-20
		 */
		toggleAccessEnabled(row, val) {
			const tip = val
				? '启用后将重新下发天波主规则及当前激活套子规则，是否继续？'
				: '禁用后将调用天波删除该门禁规则，本地数据保留，是否继续？'
			this.$confirm(tip, '确认', { type: 'warning' }).then(() => {
				setAccessEnabled({ id: row.Id, isEnabled: val }).then((res) => {
					if (res.data.success) {
						this.$message.success(res.data.msg || '操作成功')
						this.handleQuery()
					} else {
						this.$message.error(res.data.msg || '操作失败')
						this.handleQuery()
					}
				})
			}).catch(() => {
				this.handleQuery()
			})
		},
		loadSchoolSchemeProfile() {
			if (!this.DepartmentId) return
			getSchoolSchemeProfile({ schoolId: this.DepartmentId, bizType: 'AccessControl' }).then((res) => {
				if (!res.data.success) return
				const p = res.data.response || {}
				this.schemeSlot1Name = p.Slot1Name || '方案一'
				this.schemeSlot2Name = p.Slot2Name || '方案二'
				this.schoolSchemeSlot = p.ActiveSlot === 2 ? 2 : 1
				this.schemeHasBackup = !!p.HasBackup
			})
		},
		renameSchemes() {
			if (!this.DepartmentId) {
				this.$message.warning('请先选择学校')
				return
			}
			this.$prompt('请输入方案一名称（如：冬季）', '改方案名', {
				inputValue: this.schemeSlot1Name,
				confirmButtonText: '下一步'
			}).then(({ value }) => {
				const name1 = (value || '').trim()
				if (!name1) return this.$message.warning('名称不能为空')
				this.$prompt('请输入方案二名称（如：夏季）', '改方案名', {
					inputValue: this.schemeSlot2Name,
					confirmButtonText: '保存'
				}).then(({ value: value2 }) => {
					const name2 = (value2 || '').trim()
					if (!name2) return this.$message.warning('名称不能为空')
					saveSchoolSchemeProfile({
						schoolId: this.DepartmentId,
						bizType: 'AccessControl',
						slot1Name: name1,
						slot2Name: name2
					}).then((res) => {
						if (res.data.success) {
							this.schemeSlot1Name = name1
							this.schemeSlot2Name = name2
							this.$message.success('方案名称已更新')
						} else {
							this.$message.error(res.data.msg || '保存失败')
						}
					})
				}).catch(() => {})
			}).catch(() => {})
		},
		/**
		 * 全校一键切换主备（切到备时若无备套则先从当前复制）。创建于 2026-09-20
		 */
		createBackup() {
			if (!this.DepartmentId) {
				this.$message.warning('请先选择学校')
				return
			}
			this.$confirm('将把当前生效的全部门禁规则覆盖写入备用方案，是否继续？', '创建/更新备用', {
				type: 'warning'
			}).then(() => {
				this.schemeBusy = true
				createOrUpdateBackup({
					schoolId: this.DepartmentId,
					scope: 'AccessControl'
				}).then((res) => {
					this.schemeBusy = false
					if (res.data.success) {
						const batch = res.data.response || {}
						const fail = batch.FailCount || 0
						if (fail > 0) {
							this.$message.error(res.data.msg || `创建备用失败：${fail} 项未成功`)
						} else {
							this.$message.success(res.data.msg || '备用已更新')
						}
						this.loadSchoolSchemeProfile()
					} else {
						this.$message.error(res.data.msg || '操作失败')
					}
				}).catch(() => { this.schemeBusy = false })
			}).catch(() => {})
		},
		openSwitchSchemeDialog() {
			if (!this.DepartmentId) {
				this.$message.warning('请先选择学校')
				return
			}
			this.switchTargetSlot = this.schoolSchemeSlot === 2 ? 2 : 1
			this.switchSchemeDialogVisible = true
		},
		confirmSwitchScheme() {
			const targetSlot = this.switchTargetSlot === 2 ? 2 : 1
			if (targetSlot === this.schoolSchemeSlot) {
				this.$message.info('已是当前生效方案')
				this.switchSchemeDialogVisible = false
				return
			}
			if (targetSlot === 2 && !this.schemeHasBackup) {
				this.$message.warning('请先「创建/更新备用」')
				return
			}
			const label = targetSlot === 2 ? this.schemeSlot2Name : this.schemeSlot1Name
			this.$confirm(`确定将本校全部门禁规则切换为「${label}」生效？切换后可再重新配置。`, '确认切换', {
				type: 'warning'
			}).then(() => {
				this.schemeBusy = true
				batchSwitch({
					schoolId: this.DepartmentId,
					targetSlot: targetSlot,
					scope: 'AccessControl'
				}).then((res) => {
					this.schemeBusy = false
					if (res.data.success) {
						const batch = res.data.response || {}
						const fail = batch.FailCount || 0
						if (fail > 0) {
							this.$message.warning(res.data.msg || `部分失败：成功${batch.SuccessCount}，失败${fail}`)
						} else {
							this.$message.success(res.data.msg || '切换成功')
						}
						this.switchSchemeDialogVisible = false
						this.handleQuery()
						this.loadSchoolSchemeProfile()
					} else {
						this.$message.error(res.data.msg || '切换失败')
					}
				}).catch(() => { this.schemeBusy = false })
			}).catch(() => {})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		/** 勾选时保持单选。最后更新：2026-08-31 */
		dialogCheck(selection, row) {
			this.$refs.table.clearSelection()
			if (selection.length === 0) return
			if (row) this.selectCurrentRow(row)
		},
		/** 点击行选中。最后更新：2026-08-31 */
		selectCurrentRow(row) {
			if (!row) return
			this.$refs.table.clearSelection()
			this.$refs.table.toggleRowSelection(row, true)
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.currentDepartmentName = data.label || data.name || ''
			this.loadSchoolSchemeProfile()
			this.loadUserRoleAliases()
			if (this.activeTab === 'temp') {
				this.loadTempRules(1)
			} else {
				this.handleQuery()
			}

			this.loadDepartmentTree()
		},
		/**
		 * 按本校人员类型配置刷新门禁勾选/列表展示名（仅展示，下发仍用固定 0/1/2）。创建于 2026-10-16
		 */
		async loadUserRoleAliases() {
			const buildRoles = (aliasByLiveTypeId) =>
				ACCESS_USER_ROLE_BASE.map((item) => {
					const alias = item.liveTypeId ? (aliasByLiveTypeId[item.liveTypeId] || '') : ''
					return {
						...item,
						alias,
						name: alias ? `${item.baseName}·${alias}` : item.baseName,
					}
				})

			if (!this.DepartmentId) {
				this.userRoles = buildRoles({})
				return
			}
			try {
				const types = await fetchStudentLiveTypesByDeptId(this.DepartmentId)
				// 与 StudentLiveTypeResolver 兜底名一致，接口未回 DefaultLiveTypeName 时用于去重
				const systemDefaultNames = {
					live_home: '走读生',
					live_school: '住校生',
					live_home_spe: '特殊走读生',
				}
				const aliasByLiveTypeId = {}
				;(types || []).forEach((t) => {
					const id = String((t && t.LiveTypeId) || '').trim()
					if (!id) return
					const alias = String((t && t.LiveTypeName) || '').trim()
					const defaultName =
						String((t && t.DefaultLiveTypeName) || '').trim() ||
						systemDefaultNames[id] ||
						''
					// 仅本校名与默认名不同时展示，避免「学生(走读)·走读生」冗余
					if (alias && alias !== defaultName) {
						aliasByLiveTypeId[id] = alias
					}
				})
				this.userRoles = buildRoles(aliasByLiveTypeId)
			} catch (e) {
				this.userRoles = buildRoles({})
			}
		},
		/**
		 * 当前打开的规则表单（临时 / 新增 / 编辑），供人员、设备、子规则弹窗回写。创建于 2026-10-12
		 */
		currentScopeForm() {
			if (this.tempFormVisible) return this.tempForm
			return this.addFormVisible ? this.addForm : this.editForm
		},
		/**
		 * 切换日常 / 临时 Tab。创建于 2026-10-12
		 */
		onTabChange(tab) {
			if (tab === 'temp') {
				this.loadTempRules(1)
			} else {
				this.handleQuery()
			}
		},
		/**
		 * 拉取临时规则分页列表。创建于 2026-10-12
		 * @param {number} page - 页码
		 */
		loadTempRules(page) {
			if (page) this.tempPage = page
			this.tempLoading = true
			getAccessTempRuleListPage({
				departmentId: this.DepartmentId || 0,
				title: this.tempFilters.title,
				status: this.tempFilters.status,
				page: this.tempPage,
				intPageSize: 10,
			}).then((res) => {
				const data = (res && res.data && res.data.response) || {}
				this.tempRules = data.data || []
				this.tempTotal = data.dataCount || 0
			}).finally(() => {
				this.tempLoading = false
			})
		},
		tempStatusMeta(status) {
			return this.tempStatusOptions.find((x) => x.value === status) || { label: status || '-', type: 'info' }
		},
		tempReasonLabel(reason) {
			const item = this.tempReasonOptions.find((x) => x.value === reason)
			return item ? item.label : (reason || '-')
		},
		tempFormRulesByType(type) {
			return ((this.tempForm && this.tempForm.SubRules) || []).filter((r) => r.type == type)
		},
		formatDateTime(val) {
			return val ? this.formateDate('yyyy-mm-dd HH:MM', val) : '-'
		},
		/**
		 * 下发/删除时间按状态着色：下一步待发生的时间高亮，已完成置灰或绿，失败/逾期标红。创建于 2026-10-12
		 * @param {Object} row - 临时规则行
		 * @param {String} kind - push | delete
		 * @returns {{cls: String, tip: String}}
		 */
		tempTimeMeta(row, kind) {
			const status = row.Status
			const timeVal = kind === 'push' ? row.PushAt : row.DeleteAt
			const ts = timeVal ? new Date(String(timeVal).replace(/-/g, '/')).getTime() : NaN
			const overdue = !isNaN(ts) && ts < Date.now()
			if (kind === 'push') {
				if (status === 'PendingPush') return overdue ? { cls: 'is-danger', tip: '已过下发时间仍未下发' } : { cls: 'is-next', tip: '等待下发' }
				if (status === 'Pushing') return { cls: 'is-doing', tip: '下发中' }
				if (status === 'Failed') return { cls: 'is-danger', tip: row.LastError || '下发失败' }
				if (status === 'ActiveOnTb' || status === 'Deleting') return { cls: 'is-done', tip: '已下发' }
				return { cls: 'is-muted', tip: '' }
			}
			if (status === 'ActiveOnTb') return overdue ? { cls: 'is-danger', tip: '已过删除时间仍在天波，将自动重试' } : { cls: 'is-next', tip: '等待删除' }
			if (status === 'Deleting') return { cls: 'is-doing', tip: '删除中' }
			if (status === 'Finished') return { cls: 'is-done', tip: '已删除' }
			return { cls: 'is-muted', tip: '' }
		},
		/**
		 * 编辑弹窗中下发/删除时间着色与提示：下发蓝、删除橙，已过时间提示立即执行，非法标红。创建于 2026-10-12
		 * @param {String} kind - push | delete
		 * @returns {{cls: String, tip: String}}
		 */
		tempFormTimeMeta(kind) {
			const form = this.tempForm || {}
			const toTs = (v) => (v ? new Date(String(v).replace(/-/g, '/')).getTime() : NaN)
			const pushTs = toTs(form.PushAt)
			const deleteTs = toTs(form.DeleteAt)
			const now = Date.now()
			if (kind === 'push') {
				if (isNaN(pushTs)) return { cls: 'is-push', tip: '' }
				if (form.Status === 'ActiveOnTb') return { cls: 'is-warn', tip: '当前已在天波生效，保存后会先从天波撤下，再按新时间下发' }
				if (pushTs <= now) return { cls: 'is-warn', tip: '已过当前时间，保存后立即下发' }
				return { cls: 'is-push', tip: '' }
			}
			if (isNaN(deleteTs)) return { cls: 'is-delete', tip: '' }
			if (deleteTs <= now) return { cls: 'is-danger', tip: '删除时间必须晚于当前时间' }
			if (!isNaN(pushTs) && deleteTs <= pushTs) return { cls: 'is-danger', tip: '删除时间必须晚于下发时间' }
			return { cls: 'is-delete', tip: '' }
		},
		/**
		 * 打开临时规则弹窗：row 为空新增；已结束的记录复制为新建。创建于 2026-10-12
		 * @param {Object|null} row - 列表行
		 */
		openTempForm(row) {
			if (!this.DepartmentId) {
				this.$message.warning('请先选择学校')
				return
			}
			if (row && (row.Status === 'Pushing' || row.Status === 'Deleting')) {
				this.$message.warning('正在下发或删除中，请稍后再试')
				return
			}
			const copy = row && row.Status === 'Finished'
			const src = row ? JSON.parse(JSON.stringify(row)) : {}
			this.tempForm = {
				Id: row && !copy ? src.Id : 0,
				Status: row && !copy ? src.Status : '',
				SchoolId: row ? src.SchoolId : this.DepartmentId,
				Title: src.Title || '',
				ReasonType: src.ReasonType || 'Holiday',
				Remark: src.Remark || '',
				PushAt: row && !copy ? this.formateDate('yyyy-mm-dd HH:MM:SS', src.PushAt) : '',
				DeleteAt: row && !copy ? this.formateDate('yyyy-mm-dd HH:MM:SS', src.DeleteAt) : '',
				Place: src.Place || '',
				OutDeviceSns: src.OutDeviceSns || [],
				InDeviceSns: src.InDeviceSns || [],
				PersonIds: src.PersonIds || [],
				DeptIds: src.DeptIds || [],
				PassStatus: src.PassStatus || 1,
				Priority: row ? src.Priority : 9,
				SubRules: (src.SubRules || []).map((s, index) => Object.assign({}, s, { index, id: 0, thirdPartyId: copy || !row ? 0 : (s.thirdPartyId || 0) })),
			}
			this.tempCopySourceId = null
			this.tempFormVisible = true
			this.loadDailyRuleOptions()
		},
		/**
		 * 加载当前学校日常规则，供临时规则「快速复制」选择。创建于 2026-10-12
		 */
		loadDailyRuleOptions() {
			this.dailyRuleOptionsLoading = true
			getAccessControlRuleListPage({ page: 1, intPageSize: 200, departmentId: this.DepartmentId }).then((res) => {
				const data = (res && res.data && res.data.response) || {}
				this.dailyRuleOptions = data.data || []
			}).catch(() => {
				this.dailyRuleOptions = []
			}).finally(() => {
				this.dailyRuleOptionsLoading = false
			})
		},
		/**
		 * 从日常规则复制范围（场所、设备、部门/人员、通行状态），可选同时复制子规则。创建于 2026-10-12
		 * @param {string|number} ruleId - 日常规则 Id
		 */
		copyFromDailyRule(ruleId) {
			const src = this.dailyRuleOptions.find((x) => x.Id === ruleId)
			if (!src || !this.tempForm) return
			const form = this.tempForm
			const applyScope = () => {
				this.$set(form, 'Place', src.Place || '')
				this.$set(form, 'OutDeviceSns', [...(src.OutDeviceSns || [])])
				this.$set(form, 'InDeviceSns', [...(src.InDeviceSns || [])])
				this.$set(form, 'DeptIds', [...(src.DeptIds || [])])
				this.$set(form, 'PersonIds', [...(src.PersonIds || [])])
				this.$set(form, 'PassStatus', src.PassStatus || 1)
				if (!form.Title) this.$set(form, 'Title', `${src.RuleName}-临时`.slice(0, 64))
			}
			const applySubRules = () => {
				const subs = (src.SubRules || []).map((s, index) => Object.assign({}, JSON.parse(JSON.stringify(s)), { index, id: 0, thirdPartyId: 0 }))
				this.$set(form, 'SubRules', subs)
			}
			if (!(src.SubRules || []).length) {
				applyScope()
				this.$message.success('已复制场所、设备、人员范围')
				return
			}
			this.$confirm(
				`「${src.RuleName}」有 ${src.SubRules.length} 条出/入子规则，是否一起复制？复制后可直接改周几和时段。`,
				'快速复制',
				{ confirmButtonText: '范围+子规则', cancelButtonText: '仅复制范围', distinguishCancelAndClose: true, type: 'info' }
			).then(() => {
				applyScope()
				applySubRules()
				this.$message.success('已复制范围和子规则（覆盖原子规则）')
			}).catch((action) => {
				if (action === 'cancel') {
					applyScope()
					this.$message.success('已复制场所、设备、人员范围')
				} else {
					this.tempCopySourceId = null
				}
			})
		},
		/**
		 * 是否已选择关联部门或人员（不允许默认全部）。创建于 2026-10-12
		 * @param {Object} form - 规则表单
		 * @returns {Boolean}
		 */
		hasPersonScope(form) {
			return !!form && ((form.DeptIds && form.DeptIds.length > 0) || (form.PersonIds && form.PersonIds.length > 0))
		},
		submitTempForm() {
			this.$refs.tempForm.validate((valid) => {
				if (!valid) return
				const form = this.tempForm
				if (!this.hasPersonScope(form)) {
					this.$message.warning('请选择关联部门或人员')
					return
				}
				if (new Date(form.DeleteAt.replace(/-/g, '/')) <= new Date(form.PushAt.replace(/-/g, '/'))) {
					this.$message.warning('删除时间必须晚于下发时间')
					return
				}
				if (!form.SubRules || !form.SubRules.length) {
					this.$message.warning('请至少添加一条出或入门禁规则')
					return
				}
				this.tempSaving = true
				const para = Object.assign({}, form, {
					SubRules: form.SubRules.map((s, index) => Object.assign({}, s, { id: 0, index, thirdPartyId: 0 })),
				})
				saveAccessTempRule(para).then((res) => {
					if (res.data.success) {
						this.$message.success(res.data.msg || '保存成功')
						this.tempFormVisible = false
						this.loadTempRules()
					} else {
						this.$message.error(res.data.msg || '保存失败')
					}
				}).finally(() => {
					this.tempSaving = false
				})
			})
		},
		pushTempNow(row) {
			this.$confirm(`确定立即将「${row.Title}」下发到天波？`, '立即下发', { type: 'warning' }).then(() => {
				this.tempLoading = true
				pushAccessTempRuleNow({ id: row.Id }).then((res) => {
					res.data.success ? this.$message.success(res.data.msg || '已下发') : this.$message.error(res.data.msg || '下发失败')
					this.loadTempRules()
				}).catch(() => { this.tempLoading = false })
			}).catch(() => {})
		},
		finishTempNow(row) {
			const tip = row.Status === 'ActiveOnTb'
				? `确定提前结束「${row.Title}」？将立即从天波删除，平台记录保留。`
				: `确定提前结束「${row.Title}」？将不再下发天波。`
			this.$confirm(tip, '提前结束', { type: 'warning' }).then(() => {
				this.tempLoading = true
				finishAccessTempRuleNow({ id: row.Id }).then((res) => {
					res.data.success ? this.$message.success(res.data.msg || '已结束') : this.$message.error(res.data.msg || '操作失败')
					this.loadTempRules()
				}).catch(() => { this.tempLoading = false })
			}).catch(() => {})
		},
		deleteTemp(row) {
			const tip = row.Status === 'ActiveOnTb'
				? `「${row.Title}」正在天波生效，删除将先从天波删除并移除平台记录，确定删除？`
				: `确定删除临时规则「${row.Title}」？`
			this.$confirm(tip, '删除', { type: 'warning' }).then(() => {
				this.tempLoading = true
				deleteAccessTempRule({ id: row.Id }).then((res) => {
					res.data.success ? this.$message.success(res.data.msg || '删除成功') : this.$message.error(res.data.msg || '删除失败')
					this.loadTempRules()
				}).catch(() => { this.tempLoading = false })
			}).catch(() => {})
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},

		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},

		//获取用户列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters
			}
			this.listLoading = true

			testapi()

			// 测试用
			// this.users = [
			// 	{
			// 		ruleName: '测试',
			// 		place: '测试',
			// 		priority: 0,
			// 		passStatus: 1,
			// 		DeptIds: [
			// 			'639913678200901'
			// 		],
			// 		OutDeviceSns: [1],
			// 		InDeviceSns: [3],
			// 		PersonIds: [1, 2],
			// 		subRules: [
			// 			{
			// 				index: 0,
			// 				type: 1,
			// 				timePeriod: '18:00-19:00',
			// 				userRole: [0, 2],
			// 				sex: 0,
			// 				passStatus: 1,
			// 				grade: ['2'],
			// 				weekNo: [1, 3],
			// 			},
			// 			{
			// 				index: 1,
			// 				type: 2,
			// 				timePeriod: '18:00-19:00',
			// 				userRole: [0],
			// 				sex: 0,
			// 				passStatus: 2,
			// 				grade: ['2', '1'],
			// 				weekNo: [1, 3, 5],
			// 			},
			// 		],
			// 		description: '测试',
			// 	},
			// ]
			getAccessControlRuleListPage(para).then((res) => {
				this.total = res.data.response.dataCount
				this.users = res.data.response.data
				this.listLoading = false
			})
		},
		loadDepartmentTree() {
			this.departments = []
			let para = { pid: this.DepartmentId }
			getSubDepartmentTree(para).then((res) => {
				this.departments = [res.data.response]
			})
		},
		//删除
		handleDel() {
			var rows = this.multipleSelection

			if (rows.length == 0 || rows.length > 1) {
				this.$message({
					message: '请选择要删除的一行数据！',
					type: 'error',
				})
				return
			}

			var row = rows[0]

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					//NProgress.start();
					let para = { id: row.Id }
					deleteAccessControlRule(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
		//显示编辑界面
		handleEdit() {
			var rows = this.multipleSelection

			console.log(rows)

			if (rows.length == 0 || rows.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}

			var row = JSON.parse(JSON.stringify(rows[0]));

			console.log(row)

			this.suppressPassStatusWarn = true
			this.editForm = row
			this.editFormVisible = true
			this.$nextTick(() => {
				this.suppressPassStatusWarn = false
			})
		},
		/**
		 * 大规则切换为「允许通行」时弹窗确认；取消则改回禁止通行。最后更新：2026-10-29
		 * @param {'addForm'|'editForm'} formKey
		 * @param {number} val
		 */
		onMainPassStatusChange(formKey, val) {
			if (this.suppressPassStatusWarn || val !== 1) return
			const form = this[formKey]
			if (!form) return
			this.$confirm(
				'大规则设为「允许通行」将按默认放行，存在误放行风险。建议保持「禁止通行」，仅由子规则按时段放行。',
				'危险操作',
				{
					type: 'error',
					customClass: 'ac-pass-status-danger-confirm',
					confirmButtonText: '仍要允许通行',
					confirmButtonClass: 'el-button--danger ac-pass-status-danger-btn',
					cancelButtonText: '改回禁止通行',
					distinguishCancelAndClose: true,
				}
			).catch(() => {
				this.$set(form, 'PassStatus', 2)
			})
		},
		/**
		 * 提交前确认；大规则允许通行时用危险提示弹窗。最后更新：2026-10-29
		 * @param {number} passStatus
		 * @returns {Promise}
		 */
		confirmMainRuleSubmit(passStatus) {
			if (passStatus === 1) {
				return this.$confirm(
					'当前大规则为「允许通行」（危险操作），将按默认放行。确认仍要提交吗？',
					'危险操作',
					{
						type: 'error',
						customClass: 'ac-pass-status-danger-confirm',
						confirmButtonText: '仍要提交',
						confirmButtonClass: 'el-button--danger ac-pass-status-danger-btn',
						cancelButtonText: '取消',
					}
				)
			}
			return this.$confirm('确认提交吗？', '提示', {})
		},
		//显示新增界面
		handleAdd() {
			// 如果没有选择部门，则提示用户选择部门
			if (this.DepartmentId == 0) {
				this.$message({
					message: '请先选择部门',
					type: 'warning',
				});
				return;
			}

			this.addFormVisible = true
			this.addForm = {
				Id: 0,
				RuleName: '',
				Place: '',
				Priority: 0,
				PassStatus: 2, // 大规则默认禁止通行，由子规则按时段放行。最后更新：2026-10-29
				DeptIds: [],
				OutDeviceSns: [],
				InDeviceSns: [],
				PersonIds: [],
				SubRules: [],
				SchoolId: '',
				Description: '',
			}
		},
		//编辑。提交后会同步天波，可能较慢；loading 必须绑 editLoading。最后更新：2026-10-29
		editSubmit: function () {
			this.$refs.editForm.validate((valid) => {
				if (valid && !this.hasPersonScope(this.editForm)) {
					this.$message.warning('请选择关联部门或人员')
					return
				}
				if (valid) {
					this.confirmMainRuleSubmit(this.editForm.PassStatus).then(() => {
						this.editLoading = true
						const para = Object.assign({}, this.editForm)
						editAccessControlRule(para).then((res) => {
							if (res.data && res.data.success) {
								this.$message({
									message: res.data.msg || '更新成功',
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: (res.data && res.data.msg) || '更新失败',
									type: 'error',
								})
							}
						}).catch((err) => {
							const msg = (err && err.message) || '提交超时或网络异常，请稍后重试'
							this.$message.error(msg)
						}).finally(() => {
							this.editLoading = false
						})
					}).catch(() => {})
				}
			})
		},
		//新增
		addSubmit: function () {
			this.$refs.addForm.validate((valid) => {
				if (valid && !this.hasPersonScope(this.addForm)) {
					this.$message.warning('请选择关联部门或人员')
					return
				}
				if (valid) {
					this.confirmMainRuleSubmit(this.addForm.PassStatus).then(() => {
						this.addLoading = true
						//NProgress.start();

						this.addForm.SchoolId = this.DepartmentId;

						let para = Object.assign({}, this.addForm)

						console.log(this.addForm)

						addAccessControlRule(para).then((res) => {

							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
								this.addLoading = false
							}
						})
					})
				}
			})
		},
		// 添加人员。重构为【按部门】、【学生】、【教职工】三大独立 Tab。最后更新：2026-10-29
		addPersion() {
			const object = this.currentScopeForm()
			const deptIds = (object.DeptIds || []).map((x) => normalizeDeptId(x)).filter((x) => !!x)
			// 人员 Id 保持字符串，避免雪花 long 被 Number 精度丢失。最后更新：2026-10-29
			const personIds = this.normalizePersonIdKeys(object.PersonIds)

			// 递增 epoch，强制重建树实例，避免上次弹窗勾选残留到本次回显
			this.personPickerEpoch += 1
			this.personTab = 'dept'
			this.deptDirectoryScope = 'teaching'
			this.teachingDeptFilterText = ''
			this.internalDeptFilterText = ''
			this.studentDeptFilterText = ''
			this.teacherDeptFilterText = ''
			this.studentSearchName = ''
			this.teacherSearchName = ''
			this.candidateStudents = []
			this.candidateTeachers = []
			this.currentStudentDeptId = 0
			this.currentStudentDeptName = ''
			this.currentStudentDeptOrgType = ''
			this.currentStudentCampusId = ''
			this.studentFilterLiveType = ''
			this.studentFilterTagId = null
			this.studentTagOptions = []
			this.studentViewMode = 'pick'
			this.selectedStudentSearchName = ''
			this.selectedStudentTablePage = 1
			this.selectedViewRows = []
			this.selectedViewLoading = false
			this.currentTeacherDeptId = 0
			this.currentTeacherDeptName = ''

			// 回显部门勾选：记录待回显全部部门 ID，待树加载完毕后精准分流，解决初次进入数量错乱的问题
			this.pendingEchoDeptIds = [...deptIds]
			this.teachingDeptCheckedKeys = []
			this.internalDeptCheckedKeys = []

			// 回显人员初始化
			this.studentSelect = []
			this.teacherSelect = []
			this.selectedStudentsMap = {}
			this.selectedTeachersMap = {}
			this.personBaselineStudentIds = []
			this.personBaselineTeacherIds = []
			this.personBaselineTeachingKeys = []
			this.personBaselineInternalKeys = []
			this.personBaselineStudentsMap = {}
			this.personBaselineTeachersMap = {}
			this._personPickerConfirmed = false

			this.personVisible = true

			// 1. 加载家校通讯录和内部通讯录两棵树
			this.loadDirectoryTrees()

			// 2. 如果已有关联人员，批量根据 ID 分类查询学生和教职工（纯净姓名无后缀）
			if (personIds.length > 0) {
				getAccessControlPersonsByIds(personIds).then((res) => {
					const data = (res.data && res.data.response) || {}
					const students = data.Students || data.students || []
					const teachers = data.Teachers || data.teachers || []

					const stuIds = []
					students.forEach((s) => {
						const item = this.normalizeSelectedStudentFromApi(s)
						if (!item.Id) return
						stuIds.push(item.Id)
						this.$set(this.selectedStudentsMap, item.Id, item)
					})
					this.studentSelect = stuIds
					this.prefetchStudentHeadPhotos(Object.values(this.selectedStudentsMap))

					const teacherIds = []
					teachers.forEach((t) => {
						const idKey = this.toPersonIdKey(t.Id != null ? t.Id : t.id)
						if (!idKey) return
						teacherIds.push(idKey)
						this.$set(this.selectedTeachersMap, idKey, {
							Id: idKey,
							Name: t.Name || t.name || t.TeacherName || t.teacherName || '',
						})
					})
					this.teacherSelect = teacherIds
					this.snapshotPersonBaselinePeople()

					// 默认按部门；仅选了人员未选部门时切到对应人员 Tab 便于回显
					if (deptIds.length === 0) {
						if (teacherIds.length > 0 && stuIds.length === 0) {
							this.personTab = 'teacher'
						} else if (stuIds.length > 0) {
							this.personTab = 'student'
						}
					}
					this.$nextTick(() => this.autoSelectDefaultStudentDept())
				}).catch(() => {
					this.snapshotPersonBaselinePeople()
				})
			} else {
				this.snapshotPersonBaselinePeople()
			}
		},
		/**
		 * 进入学生 Tab 且尚未点选时，默认选中左侧第一个节点并加载名单（不展开）。最后更新：2026-10-29
		 */
		autoSelectDefaultStudentDept() {
			if (this.personTab !== 'student') return
			if (this.currentStudentDeptId) return
			const data = (this.teachingDeptTree || [])[0]
			if (!data) return
			const key = data.value != null ? data.value : data.Id
			if (key == null || key === '') return

			this.$nextTick(() => {
				if (this.personTab !== 'student' || this.currentStudentDeptId) return
				const tree = this.$refs.studentDeptTree
				if (!tree) return
				tree.setCurrentKey(key)
				const node = tree.getNode(key)
				this.handleStudentDeptClick(node && node.data ? node.data : data, node || null)
			})
		},
		/**
		 * 比较当前勾选相对底稿的新增/删除数量。最后更新：2026-10-29
		 * @param {'number'|'dept'} mode
		 */
		diffIdSets(currentList, baselineList, mode) {
			const toKey = (x) => {
				if (mode === 'dept') return normalizeDeptId(x) || String(x || '')
				if (mode === 'person') return this.toPersonIdKey(x)
				const n = Number(x)
				return Number.isNaN(n) ? '' : String(n)
			}
			const current = new Set((currentList || []).map(toKey).filter(Boolean))
			const baseline = new Set((baselineList || []).map(toKey).filter(Boolean))
			let added = 0
			let removed = 0
			current.forEach((id) => { if (!baseline.has(id)) added += 1 })
			baseline.forEach((id) => { if (!current.has(id)) removed += 1 })
			return { added, removed }
		},
		/** 记录打开时人员底稿。最后更新：2026-10-29 */
		snapshotPersonBaselinePeople() {
			this.personBaselineStudentIds = this.normalizePersonIdKeys(this.studentSelect)
			this.personBaselineTeacherIds = this.normalizePersonIdKeys(this.teacherSelect)
			this.personBaselineStudentsMap = JSON.parse(JSON.stringify(this.selectedStudentsMap || {}))
			this.personBaselineTeachersMap = JSON.parse(JSON.stringify(this.selectedTeachersMap || {}))
		},
		/** 记录打开时部门底稿。最后更新：2026-10-29 */
		snapshotPersonBaselineDepts() {
			this.personBaselineTeachingKeys = [...(this.teachingDeptCheckedKeys || [])]
			this.personBaselineInternalKeys = [...(this.internalDeptCheckedKeys || [])]
		},
		/** 取消/关闭时还原到打开底稿。最后更新：2026-10-29 */
		restorePersonBaseline() {
			this.studentSelect = [...(this.personBaselineStudentIds || [])]
			this.teacherSelect = [...(this.personBaselineTeacherIds || [])]
			this.selectedStudentsMap = JSON.parse(JSON.stringify(this.personBaselineStudentsMap || {}))
			this.selectedTeachersMap = JSON.parse(JSON.stringify(this.personBaselineTeachersMap || {}))
			this.teachingDeptCheckedKeys = [...(this.personBaselineTeachingKeys || [])]
			this.internalDeptCheckedKeys = [...(this.personBaselineInternalKeys || [])]
			this.$nextTick(() => {
				// 弹窗 destroy-on-close 后树可能已卸载，仅在仍挂载时回写勾选
				if (this.$refs.teachingDeptTree || this.$refs.internalDeptTree) {
					this.applyDeptTreeCheckedKeys()
				}
				this.syncStudentTableSelection()
			})
		},
		cancelPersonPicker() {
			this.restorePersonBaseline()
			this._personPickerConfirmed = true // 已手动还原，关闭时不再二次还原
			this.personVisible = false
		},
		/**
		 * 人员 Id 转稳定字符串键（雪花 long 不可 Number）。最后更新：2026-10-29
		 */
		toPersonIdKey(id) {
			if (id == null || id === '') return ''
			const s = String(id).trim()
			if (!s || s === '0' || s === 'NaN') return ''
			return s
		},
		normalizePersonIdKeys(ids) {
			const out = []
			const seen = new Set()
			;(ids || []).forEach((x) => {
				const key = this.toPersonIdKey(x)
				if (!key || seen.has(key)) return
				seen.add(key)
				out.push(key)
			})
			return out
		},
		/** @deprecated 兼容旧调用；请用 normalizePersonIdKeys */
		normalizePersonIds(ids) {
			return this.normalizePersonIdKeys(ids)
		},
		/**
		 * 收集树形结构中所有节点的主键集合。创建于 2026-09-08
		 */
		collectTreeNodeKeys(treeNodes) {
			const keys = new Set()
			const traverse = (nodes) => {
				if (!nodes || !Array.isArray(nodes)) return
				nodes.forEach((n) => {
					const val = normalizeDeptId(n.value || n.Id)
					if (val) keys.add(val)
					if (n.children && n.children.length) {
						traverse(n.children)
					}
				})
			}
			traverse(treeNodes)
			return keys
		},
		/**
		 * 去除通讯录中的学校根节点，仅展示学校下属的可选部门。
		 * 家校树和内部树共用学校 ID，根节点不能作为 DeptIds 保存。
		 */
		normalizeDirectoryTree(root, scopeId) {
			if (!root) return []

			const rootValue = normalizeDeptId(root.value || root.Id)
			const currentScopeId = normalizeDeptId(scopeId)
			let nodes = !rootValue && root.children && root.children.length
				? root.children
				: [root]

			// 接口可能返回虚拟平台根节点，也可能直接返回学校根节点。
			// 两种情况下都剥掉当前学校节点，避免学校 ID 进入勾选结果。
			const scopeNode = nodes.find((node) => deptIdsEqual(node.value || node.Id, currentScopeId))
			if (scopeNode) {
				nodes = scopeNode.children || []
			}

			return nodes
		},
		/**
		 * 将部门勾选写入 el-tree：无论有无勾选都先清空再设置，避免上次残留。
		 * 设置后再回读 getCheckedKeys，使计数与父子联动后的视觉一致。最后更新：2026-10-29
		 */
		applyDeptTreeCheckedKeys() {
			const normalizeKeys = (keys) => {
				const out = []
				const seen = new Set()
				;(keys || []).forEach((x) => {
					const id = normalizeDeptId(x)
					if (!id || seen.has(id)) return
					seen.add(id)
					out.push(id)
				})
				return out
			}
			const getInitialCheckedKeys = (tree, keys) => {
				const normalizedKeys = normalizeKeys(keys)
				const keySet = new Set(normalizedKeys)
				const hasCheckedDescendant = (node) => (node.childNodes || []).some((childNode) => {
					const childKey = normalizeDeptId(childNode.key)
					return keySet.has(childKey) || hasCheckedDescendant(childNode)
				})
				// 父级与部分子级同时存在时只回显子级，让父级显示半选横杠；
				// 父级单独存在时保留父级，仍可按当前组织树展开全部子级。
				return normalizedKeys.filter((key) => {
					const node = tree.getNode && tree.getNode(key)
					return !node || !hasCheckedDescendant(node)
				})
			}
			const teachingTree = this.$refs.teachingDeptTree
			if (teachingTree) {
				teachingTree.setCheckedKeys([])
				const teachingKeys = getInitialCheckedKeys(teachingTree, this.teachingDeptCheckedKeys)
				if (teachingKeys.length) {
					teachingTree.setCheckedKeys(teachingKeys)
				}
				this.teachingDeptCheckedKeys = normalizeKeys(teachingTree.getCheckedKeys())
			}
			const internalTree = this.$refs.internalDeptTree
			if (internalTree) {
				internalTree.setCheckedKeys([])
				const internalKeys = getInitialCheckedKeys(internalTree, this.internalDeptCheckedKeys)
				if (internalKeys.length) {
					internalTree.setCheckedKeys(internalKeys)
				}
				this.internalDeptCheckedKeys = normalizeKeys(internalTree.getCheckedKeys())
			}
		},
		/**
		 * 加载家校通讯录与内部通讯录组织树。创建于 2026-09-08
		 */
		loadDirectoryTrees() {
			this.deptTreeLoading = true
			const scopeId = this.DepartmentId || 0

			const p1 = getTeachingDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
				.then((res) => {
					const root = res && res.data && res.data.response
					if (!root) {
						this.teachingDeptTree = []
						return
					}
					this.teachingDeptTree = this.normalizeDirectoryTree(root, scopeId)
				})
				.catch(() => {
					this.teachingDeptTree = []
				})

			const p2 = getInternalDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
				.then((res) => {
					const root = res && res.data && res.data.response
					if (!root) {
						this.internalDeptTree = []
						return
					}
					this.internalDeptTree = this.normalizeDirectoryTree(root, scopeId)
				})
				.catch(() => {
					this.internalDeptTree = []
				})

			Promise.all([p1, p2]).finally(() => {
				this.deptTreeLoading = false

				// 根据两棵树各自实际包含的部门节点，精准分流回显 ID；无匹配时也必须清空，不能跳过。最后更新：2026-10-29
				const echoIds = (this.pendingEchoDeptIds || []).map((x) => normalizeDeptId(x)).filter((x) => !!x)
				const teachingKeySet = this.collectTreeNodeKeys(this.teachingDeptTree)
				const internalKeySet = this.collectTreeNodeKeys(this.internalDeptTree)
				this.teachingDeptCheckedKeys = echoIds.filter((id) => teachingKeySet.has(id))
				this.internalDeptCheckedKeys = echoIds.filter((id) => internalKeySet.has(id))

				// destroy-on-close / :key 重建后，需等弹窗内容挂载再回勾
				this.$nextTick(() => {
					this.applyDeptTreeCheckedKeys()
					this.expandDefaultRootNodes()
					this.snapshotPersonBaselineDepts()
					this.autoSelectDefaultStudentDept()
					// 若首帧 refs 尚未就绪，再补一次回勾
					if (!this.$refs.teachingDeptTree && !this.$refs.internalDeptTree && this.personVisible) {
						this.$nextTick(() => {
							this.applyDeptTreeCheckedKeys()
							this.expandDefaultRootNodes()
							this.snapshotPersonBaselineDepts()
						})
					}
				})
			})
		},
		/**
		 * 默认仅展开部门树的首个根节点（无需全部展开，展开一个即可）。创建于 2026-09-08
		 */
		expandDefaultRootNodes() {
			const treeRefs = ['studentDeptTree', 'teacherDeptTree', 'teachingDeptTree', 'internalDeptTree']
			treeRefs.forEach((refName) => {
				const tree = this.$refs[refName]
				if (tree && tree.store) {
					const allNodes = (tree.store._getAllNodes && tree.store._getAllNodes()) || []
					allNodes.forEach((node) => {
						node.expanded = false
					})
					if (tree.store.root && tree.store.root.childNodes && tree.store.root.childNodes.length > 0) {
						tree.store.root.childNodes[0].expanded = true
					}
				}
			})
		},
		/**
		 * 部门模式：切换家校 / 内部通讯录。创建于 2026-09-08
		 */
		setDeptDirectoryScope(scope) {
			if (scope !== 'teaching' && scope !== 'internal') return
			if (this.deptDirectoryScope === scope) return

			// 切换前同步保存当前树的勾选状态
			if (this.deptDirectoryScope === 'teaching' && this.$refs.teachingDeptTree) {
				this.teachingDeptCheckedKeys = (this.$refs.teachingDeptTree.getCheckedKeys() || [])
					.map((x) => normalizeDeptId(x)).filter((x) => !!x)
			} else if (this.deptDirectoryScope === 'internal' && this.$refs.internalDeptTree) {
				this.internalDeptCheckedKeys = (this.$refs.internalDeptTree.getCheckedKeys() || [])
					.map((x) => normalizeDeptId(x)).filter((x) => !!x)
			}

			this.deptDirectoryScope = scope

			this.$nextTick(() => {
				this.applyDeptTreeCheckedKeys()
				this.expandDefaultRootNodes()
			})
		},
		/**
		 * 部门树勾选变更回调
		 */
		onTeachingDeptCheck() {
			if (this.$refs.teachingDeptTree) {
				this.teachingDeptCheckedKeys = (this.$refs.teachingDeptTree.getCheckedKeys() || [])
					.map((x) => normalizeDeptId(x)).filter((x) => !!x)
			}
		},
		onInternalDeptCheck() {
			if (this.$refs.internalDeptTree) {
				this.internalDeptCheckedKeys = (this.$refs.internalDeptTree.getCheckedKeys() || [])
					.map((x) => normalizeDeptId(x)).filter((x) => !!x)
			}
		},
		/**
		 * 部门树节点本地过滤
		 */
		filterDeptNode(value, data) {
			if (!value) return true
			const label = data.label || data.Name || ''
			return label.toLowerCase().indexOf(value.toLowerCase().trim()) !== -1
		},
		/**
		 * 部门树节点组织类型色标（统一参考 DepartmentPane 风格）。创建于 2026-09-08
		 */
		nodeTone(data) {
			if (!data) return 'default'
			const type = String(data.DeptOrgType || data.deptOrgType || '').toLowerCase()
			if (type === 'platform') return 'platform'
			if (type === 'allschools' || type === 'school' || type === 'affiliateschool') return 'school'
			if (type === 'campus') return 'campus'
			if (type === 'period' || type === 'stage') return 'period'
			if (type === 'grade') return 'grade'
			if (type === 'class') return 'class'
			if (data.BigType === 0 || data.bigType === 0) return 'internal'
			return 'default'
		},
		/**
		 * 学生模式：点击左侧教学组织架构树节点（班级）
		 */
		handleStudentDeptClick(data, node) {
			this.currentStudentDeptId = normalizeDeptId(data.value || data.Id) || ''
			this.currentStudentDeptName = data.label || data.Name || ''
			const deptType = String((data.DeptOrgType != null ? data.DeptOrgType : data.deptOrgType) || '').toLowerCase()
			this.currentStudentDeptOrgType = deptType || 'class'
			this.currentStudentCampusId = this.resolveCampusIdFromTreeNode(node) || (deptType === 'campus' ? this.currentStudentDeptId : '')
			this.studentSearchName = ''
			this.studentFilterLiveType = ''
			this.studentFilterTagId = null
			this.studentTagOptions = []
			this.studentTablePage = 1
			this.loadStudentCandidates()
		},
		handleStudentSearch() {
			this.studentTablePage = 1
			this.loadStudentCandidates()
		},
		/** 从树节点向上解析校区 Id。最后更新：2026-10-29 */
		resolveCampusIdFromTreeNode(node) {
			let n = node
			while (n && n.data) {
				const t = String((n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType) || '').toLowerCase()
				if (t === 'campus') return treeNodeDeptId(n.data) || normalizeDeptId(n.data.value || n.data.Id) || ''
				n = n.parent
			}
			return ''
		},
		/**
		 * 加载学生候选人（按班级/年级精准拉取），并附带学生标签。最后更新：2026-10-29
		 */
		loadStudentCandidates() {
			const deptId = this.currentStudentDeptId || this.DepartmentId
			if (!deptId) return

			this.studentCandidatesLoading = true

			getStudentSelectList({
				departmentId: deptId,
				name: (this.studentSearchName || '').trim(),
			}).then((res) => {
				const list = (res.data && res.data.response) || []
				this._studentTableSyncing = true
				this.candidateStudents = list.map((s) => ({
					Id: this.toPersonIdKey(s.Id != null ? s.Id : s.id),
					Name: s.Name || s.name || s.StuName || s.stuName || '',
					LiveType: s.LiveType || s.liveType || '',
					StudentTags: [],
					DepartmentName: s.DepartmentName || s.departmentName || this.currentStudentDeptName || '',
					HeadPhotoImage: s.HeadPhotoImage || s.headPhotoImage || '',
				})).filter((s) => !!s.Id)
				this.prefetchStudentHeadPhotos(this.candidateStudents)
				this.mergeSelectedDetailsFromCandidates()
				return this.enrichCandidateStudentsWithTags()
			}).catch(() => {
				this._studentTableSyncing = true
				this.candidateStudents = []
				this.studentTagOptions = []
			}).finally(() => {
				this.studentCandidatesLoading = false
				this.$nextTick(() => {
					this.updateStudentTableHeight()
					this.syncStudentTableSelection()
				})
			})
		},
		/** 预取学生头像 OSS 地址。最后更新：2026-10-29 */
		prefetchStudentHeadPhotos(rows) {
			const list = rows || []
			if (!list.length || !this.prefetchListOssMedia) return
			this.prefetchListOssMedia(list, 'HeadPhotoImage')
		},
		/** 写入已选缓存（含部门/头像）。最后更新：2026-10-29 */
		toSelectedStudentCache(row) {
			return {
				Id: this.toPersonIdKey(row.Id),
				Name: row.Name || '',
				LiveType: row.LiveType || '',
				StudentTags: row.StudentTags || [],
				DepartmentName: row.DepartmentName || this.currentStudentDeptName || '',
				HeadPhotoImage: row.HeadPhotoImage || '',
			}
		},
		/**
		 * 按当前名单学生 Id 批量映射标签（不受分页 200 截断）。最后更新：2026-11-02
		 */
		enrichCandidateStudentsWithTags() {
			const deptId = this.currentStudentDeptId
			if (!deptId || !(this.candidateStudents || []).length) {
				this.studentTagOptions = []
				return Promise.resolve()
			}

			return fetchAndMapStudentTags({
				deptId,
				campusId: this.currentStudentCampusId,
				deptOrgType: this.currentStudentDeptOrgType,
				rows: this.candidateStudents,
				rowIdKey: 'Id',
			}).then(({ tagOptions, rows }) => {
				this.studentTagOptions = tagOptions || []
				this._studentTableSyncing = true
				this.candidateStudents = (rows || []).map((s) => ({
					...s,
					StudentTags: s.studentTags || s.StudentTags || [],
				}))
				this.mergeSelectedDetailsFromCandidates()
				this.$nextTick(() => this.syncStudentTableSelection())
			}).catch(() => {
				this.studentTagOptions = []
			})
		},
		studentTagCount(tagId) {
			const id = String(tagId)
			return (this.candidateStudents || []).filter((s) =>
				(s.StudentTags || []).some((t) => String(t.id) === id)
			).length
		},
		/** 是否匹配当前人员类型 / 学生标签筛选。最后更新：2026-10-29 */
		studentMatchesQuickFilter(student) {
			if (!student) return false
			if (this.studentFilterLiveType) {
				const live = (student.LiveType || '').trim() || '未设置'
				if (live !== this.studentFilterLiveType) return false
			}
			if (this.studentFilterTagId) {
				const hit = (student.StudentTags || []).some((t) => String(t.id) === String(this.studentFilterTagId))
				if (!hit) return false
			}
			return true
		},
		onStudentTablePageChange(page) {
			// 先锁住 selection-change，避免翻页时空选事件把当页 Id 从已选里删掉
			lockPersonScopeSelectionSync(this, '_studentTableSyncing')
			this.studentTablePage = page
			this.$nextTick(() => this.syncStudentTableSelection())
		},
		/** 快捷筛选变更后回到第一页并回勾。最后更新：2026-10-29 */
		onStudentQuickFilterChange() {
			lockPersonScopeSelectionSync(this, '_studentTableSyncing')
			this.studentTablePage = 1
			this.$nextTick(() => {
				this.updateStudentTableHeight()
				this.syncStudentTableSelection()
			})
		},
		/** 按容器实测表格高度，避免末行被裁切。最后更新：2026-10-29 */
		updateStudentTableHeight() {
			const wrap = this.studentViewMode === 'selected'
				? this.$refs.studentSelectedTableWrap
				: this.$refs.studentTableWrap
			if (!wrap) return
			const h = Math.floor(wrap.clientHeight || 0)
			if (h >= 120) this.studentTableHeight = h
		},
		/** 切换「按范围选 / 已选」视图。最后更新：2026-10-29 */
		onStudentViewModeChange(mode) {
			if (mode === 'selected') {
				this.selectedStudentTablePage = 1
				this.loadSelectedViewRows()
			}
			this.$nextTick(() => {
				this.updateStudentTableHeight()
				if (mode === 'pick') this.syncStudentTableSelection()
			})
		},
		/**
		 * 将接口学生项规范为已选缓存。Id 保持字符串。最后更新：2026-10-29
		 */
		normalizeSelectedStudentFromApi(s) {
			if (!s) {
				return { Id: '', Name: '', LiveType: '', StudentTags: [], DepartmentName: '', HeadPhotoImage: '' }
			}
			const idKey = this.toPersonIdKey(s.Id != null ? s.Id : s.id)
			const rawTags = s.StudentTags || s.studentTags || []
			return {
				Id: idKey,
				Name: s.Name || s.name || s.StuName || s.stuName || '',
				LiveType: s.LiveType || s.liveType || '',
				StudentTags: (rawTags || []).map((t) => ({
					id: t.id != null ? t.id : t.Id,
					tagName: t.tagName != null ? t.tagName : (t.TagName || ''),
					categoryName: t.categoryName != null ? t.categoryName : (t.CategoryName || ''),
					applyToDismissal: t.applyToDismissal != null ? !!t.applyToDismissal : !!t.ApplyToDismissal,
				})).filter((t) => t.id != null && t.id !== ''),
				DepartmentName: s.DepartmentName || s.departmentName || '',
				HeadPhotoImage: s.HeadPhotoImage || s.headPhotoImage || '',
			}
		},
		/**
		 * 组装已选视图一行（优先 API / map / 当前候选）。最后更新：2026-10-29
		 */
		buildSelectedViewRow(idKey, sources) {
			const api = (sources && sources.api) || {}
			const cached = (sources && sources.cached) || {}
			const cand = (sources && sources.cand) || {}
			const displayName =
				String(api.Name || cached.Name || cand.Name || '').trim() ||
				(idKey ? `学生(${idKey})` : '学生')
			return {
				Id: idKey,
				displayName,
				LiveType: api.LiveType || cached.LiveType || cand.LiveType || '',
				StudentTags: (api.StudentTags && api.StudentTags.length)
					? api.StudentTags
					: (cached.StudentTags && cached.StudentTags.length)
						? cached.StudentTags
						: (cand.StudentTags || []),
				DepartmentName: api.DepartmentName || cached.DepartmentName || cand.DepartmentName || '',
				HeadPhotoImage: api.HeadPhotoImage || cached.HeadPhotoImage || cand.HeadPhotoImage || '',
			}
		},
		/**
		 * 加载已选视图行：先本地拼一版，再请求接口补全。最后更新：2026-10-29
		 */
		loadSelectedViewRows() {
			const ids = this.normalizePersonIdKeys(this.studentSelect)
			const candMap = {}
			;(this.candidateStudents || []).forEach((c) => {
				const k = this.toPersonIdKey(c.Id)
				if (k) candMap[k] = c
			})

			this.selectedViewRows = ids.map((id) =>
				this.buildSelectedViewRow(id, {
					cached: this.selectedStudentsMap[id] || {},
					cand: candMap[id] || {},
				})
			)

			if (!ids.length) {
				this.selectedViewLoading = false
				return Promise.resolve()
			}

			this.selectedViewLoading = true
			return getAccessControlPersonsByIds(ids)
				.then((res) => {
					const data = (res.data && res.data.response) || {}
					const students = data.Students || data.students || []
					const apiMap = {}
					students.forEach((s) => {
						const item = this.normalizeSelectedStudentFromApi(s)
						if (!item.Id) return
						apiMap[item.Id] = item
						const prev = this.selectedStudentsMap[item.Id] || {}
						this.$set(this.selectedStudentsMap, item.Id, {
							...prev,
							...item,
							Name: item.Name || prev.Name || '',
							LiveType: item.LiveType || prev.LiveType || '',
							DepartmentName: item.DepartmentName || prev.DepartmentName || '',
							HeadPhotoImage: item.HeadPhotoImage || prev.HeadPhotoImage || '',
							// 优先用接口最新标签，避免已选视图一直显示「未设置」。最后更新：2026-11-02
							StudentTags:
								item.StudentTags && item.StudentTags.length
									? item.StudentTags
									: prev.StudentTags || [],
						})
					})
					this.selectedViewRows = ids.map((id) =>
						this.buildSelectedViewRow(id, {
							api: apiMap[id] || {},
							cached: this.selectedStudentsMap[id] || {},
							cand: candMap[id] || {},
						})
					)
					this.prefetchStudentHeadPhotos(this.selectedViewRows)
				})
				.catch(() => {})
				.finally(() => {
					this.selectedViewLoading = false
					this.$nextTick(() => this.updateStudentTableHeight())
				})
		},
		/**
		 * 当前范围名单加载后，回填已选缓存。最后更新：2026-10-29
		 */
		mergeSelectedDetailsFromCandidates() {
			const selectedSet = new Set(this.normalizePersonIdKeys(this.studentSelect))
			;(this.candidateStudents || []).forEach((row) => {
				const idKey = this.toPersonIdKey(row.Id)
				if (!idKey || !selectedSet.has(idKey)) return
				const prev = this.selectedStudentsMap[idKey] || {}
				this.$set(this.selectedStudentsMap, idKey, {
					...prev,
					...this.toSelectedStudentCache(row),
					StudentTags:
						row.StudentTags && row.StudentTags.length
							? row.StudentTags
							: prev.StudentTags || [],
				})
			})
			if (this.studentViewMode === 'selected') {
				this.loadSelectedViewRows()
			}
		},
		onSelectedStudentTablePageChange(page) {
			this.selectedStudentTablePage = page
		},
		/** 从已选列表移除一名学生。最后更新：2026-10-29 */
		removeSelectedStudent(id) {
			const idKey = this.toPersonIdKey(id)
			if (!idKey) return
			lockPersonScopeSelectionSync(this, '_studentTableSyncing')
			this.studentSelect = (this.studentSelect || []).filter((x) => this.toPersonIdKey(x) !== idKey)
			this.$delete(this.selectedStudentsMap, idKey)
			this.selectedViewRows = (this.selectedViewRows || []).filter((r) => this.toPersonIdKey(r.Id) !== idKey)
			const total = (this.selectedViewFilteredRows || []).length
			const maxPage = Math.max(1, Math.ceil(total / (this.studentTablePageSize || 10)))
			if (this.selectedStudentTablePage > maxPage) this.selectedStudentTablePage = maxPage
			this.$nextTick(() => {
				if (this.studentViewMode === 'pick') this.syncStudentTableSelection()
			})
		},
		/**
		 * 按已选 Id 回勾当前页表格。最后更新：2026-10-29
		 */
		syncStudentTableSelection() {
			const selectedSet = new Set(this.normalizePersonIdKeys(this.studentSelect))
			syncPersonScopeElTableSelection({
				vm: this,
				tableRef: 'studentPeopleTable',
				rows: this.studentPagedRows || [],
				flagKey: '_studentTableSyncing',
				isSelected: (row) => selectedSet.has(this.toPersonIdKey(row.Id)),
			})
		},
		onStudentRowClick(row) {
			if (this._studentTableSyncing) return
			const table = this.$refs.studentPeopleTable
			if (!table || !row) return
			table.toggleRowSelection(row)
		},
		onStudentTableSelectionChange(selection) {
			if (this._studentTableSyncing) return
			const pageIds = new Set((this.studentPagedRows || []).map((r) => this.toPersonIdKey(r.Id)).filter(Boolean))
			const selectedOnPage = new Set((selection || []).map((r) => this.toPersonIdKey(r.Id)).filter(Boolean))
			const next = new Set(this.normalizePersonIdKeys(this.studentSelect))
			pageIds.forEach((id) => {
				if (selectedOnPage.has(id)) {
					next.add(id)
					const row = (this.candidateStudents || []).find((s) => this.toPersonIdKey(s.Id) === id)
					if (row) {
						this.$set(this.selectedStudentsMap, id, this.toSelectedStudentCache(row))
					}
				} else {
					next.delete(id)
				}
			})
			this.studentSelect = Array.from(next)
		},
		/** 全选当前筛选结果（跨页）。最后更新：2026-10-29 */
		selectAllCurrentStudentDept() {
			const rows = this.studentFilteredRows || []
			if (!rows.length) return
			lockPersonScopeSelectionSync(this, '_studentTableSyncing')
			const next = new Set(this.normalizePersonIdKeys(this.studentSelect))
			rows.forEach((row) => {
				const idKey = this.toPersonIdKey(row.Id)
				if (!idKey) return
				next.add(idKey)
				this.$set(this.selectedStudentsMap, idKey, this.toSelectedStudentCache(row))
			})
			this.studentSelect = Array.from(next)
			this.$nextTick(() => this.syncStudentTableSelection())
			this.$message.success(`已勾选当前范围 ${rows.length} 人`)
		},
		clearCurrentStudentDept() {
			lockPersonScopeSelectionSync(this, '_studentTableSyncing')
			const ids = new Set((this.candidateStudents || []).map((s) => this.toPersonIdKey(s.Id)).filter(Boolean))
			this.studentSelect = (this.studentSelect || []).filter((id) => !ids.has(this.toPersonIdKey(id)))
			this.$nextTick(() => this.syncStudentTableSelection())
		},
		clearAllSelectedStudents() {
			lockPersonScopeSelectionSync(this, '_studentTableSyncing')
			this.studentSelect = []
			this.selectedStudentsMap = {}
			this.selectedViewRows = []
			this.selectedStudentTablePage = 1
			this.$nextTick(() => {
				if (this.studentViewMode === 'pick') this.syncStudentTableSelection()
			})
		},
		/**
		 * 获取学生就读类型徽标样式类。创建于 2026-09-08
		 */
		studentLiveTypeClass(type) {
			if (!type) return 'tag-default'
			const str = String(type).trim()
			if (str.indexOf('走读') !== -1 && str.indexOf('特殊') === -1) return 'tag-day'
			if (str.indexOf('住校') !== -1) return 'tag-board'
			if (str.indexOf('特殊') !== -1) return 'tag-special'
			return 'tag-default'
		},
		/**
		 * 教职工模式：点击左侧内部组织架构树节点（部门/处室）
		 */
		handleTeacherDeptClick(data) {
			this.currentTeacherDeptId = normalizeDeptId(data.value || data.Id) || ''
			this.currentTeacherDeptName = data.label || data.Name || ''
			this.teacherSearchName = ''
			this.loadTeacherCandidates()
		},
		handleTeacherSearch() {
			this.loadTeacherCandidates()
		},
		/**
		 * 加载教职工候选人。创建于 2026-09-08
		 */
		loadTeacherCandidates() {
			const deptId = this.currentTeacherDeptId || this.DepartmentId
			if (!deptId) return

			this.teacherCandidatesLoading = true

			getTeacherMasterListPage({
				page: 1,
				departmentId: deptId,
				intPageSize: 1000,
				teacherName: (this.teacherSearchName || '').trim(),
			}).then((res) => {
				const page = (res.data && res.data.response) || {}
				const list = page.data || []
				this.candidateTeachers = list.map((t) => ({
					Id: Number(t.Id),
					Name: t.TeacherName || t.Name || '', // 纯净姓名，无任何后缀
				}))
			}).catch(() => {
				this.candidateTeachers = []
			}).finally(() => {
				this.teacherCandidatesLoading = false
			})
		},
		/**
		 * 教职工穿梭框选择变更
		 */
		handleTeacherTransferChange(currentKeys, direction, movedKeys) {
			if (direction === 'right') {
				(movedKeys || []).forEach((id) => {
					const numId = Number(id)
					const found = this.transferTeacherData.find((u) => Number(u.Id) === numId)
					if (found) {
						this.$set(this.selectedTeachersMap, numId, {
							Id: numId,
							Name: found.Name,
						})
					}
				})
			} else if (direction === 'left') {
				(movedKeys || []).forEach((id) => {
					const numId = Number(id)
					this.$delete(this.selectedTeachersMap, numId)
				})
			}
		},
		/**
		 * 确认保存人员/部门关联（写入表单后生效）。最后更新：2026-10-29
		 */
		confirmAPerson() {
			if (this.deptTreeLoading) {
				this.$message.warning('部门树加载中，请稍后再确认')
				return
			}
			// 1. 汇总家校和内部通讯录勾选的部门（优先读树；树未就绪时用已同步的 keys，避免读到上次残留）
			const teachingKeys = (this.$refs.teachingDeptTree
				? this.$refs.teachingDeptTree.getCheckedKeys()
				: this.teachingDeptCheckedKeys) || []
			const internalKeys = (this.$refs.internalDeptTree
				? this.$refs.internalDeptTree.getCheckedKeys()
				: this.internalDeptCheckedKeys) || []
			const departments = []
			const seen = new Set()
			;[...teachingKeys, ...internalKeys].forEach((x) => {
				const id = normalizeDeptId(x)
				if (!id || seen.has(id) || deptIdsEqual(id, this.DepartmentId)) return
				seen.add(id)
				departments.push(id)
			})

			// 2. 汇总已选学生和教职工（字符串 Id，避免雪花精度丢失）
			const users = this.normalizePersonIdKeys([
				...(this.studentSelect || []),
				...(this.teacherSelect || []),
			])

			const target = this.currentScopeForm()
			if (target) {
				this.$set(target, 'DeptIds', departments)
				this.$set(target, 'PersonIds', users)
			}
			this._personPickerConfirmed = true
			this.personVisible = false
		},
		// 添加设备（直接查询当前学校下的门禁设备列表，无需无意义的部门树）。最后更新：2026-09-08
		addDevice(isIn) {
			const object = this.currentScopeForm()
			if (isIn) {
				this.deviceAddTitle = '添加入设备'
				this.deviceSelect = JSON.parse(JSON.stringify(object.InDeviceSns || []))
			} else {
				this.deviceAddTitle = '添加出设备'
				this.deviceSelect = JSON.parse(
					JSON.stringify(object.OutDeviceSns || [])
				)
			}
			this.deviceVisible = true
			this.deviceList = []
			this.deviceLoading = true
			getDeviveList({ departmentId: this.DepartmentId, type: 4 }).then((res) => {
				this.deviceList = (res && res.data && res.data.response) || []
			}).catch(() => {
				this.deviceList = []
			}).finally(() => {
				this.deviceLoading = false
			})
		},
		confirmDevices() {
			const object = this.currentScopeForm()
			const selected = Array.isArray(this.deviceSelect) ? [...this.deviceSelect] : []
			if (this.deviceAddTitle == '添加出设备') {
				this.$set(object, 'OutDeviceSns', selected)
			} else {
				this.$set(object, 'InDeviceSns', selected)
			}
			this.deviceVisible = false
		},
		getRuleForType(obj, type) {
			obj = obj || []
			return obj.filter((item) => {
				return item.type == type
			})
		},
		listToString(list, map) {
			return list
				.map((item) => {
					return map.get(item) || '其他'
				})
				.join(',')
		},
		handleEditRule(type, obj) {
			this.addRule(type, obj)
		},
		handleDeleteRule(obj) {
			const object = this.currentScopeForm()
			let temp = JSON.parse(JSON.stringify(object.SubRules))
			temp.splice(obj.index, 1)
			temp = temp.map((item, index) => {
				item.index = index
				return item
			})
			this.$set(object, 'SubRules', temp)
		},
		// 添加规则
		addRule(type = 1, obj = null) {
			if (!obj) {
				let now = new Date(new Date().setMinutes(0)).setSeconds(0)
				// 一小时后
				let last = new Date(
					new Date(new Date().setHours(new Date().getHours() + 1)).setMinutes(0)
				).setSeconds(0)
				if (new Date().getHours() > 23) {
					now = new Date(this.formateDate('yyyy-mm-dd 23:00:00'))
					last = new Date(this.formateDate('yyyy-mm-dd 23:59:00'))
				}
				this.ruleParam = {
					id: '',
					index: -1,
					type: type,
					timePeriod: [now, last],
					userRole: [],
					sex: 0,
					passStatus: 1,
					grade: [],
					weekNo: [],
				}
			} else {
				let temp = JSON.parse(JSON.stringify(obj))
				let times = temp.timePeriod.split('-')
				temp.timePeriod = [
					new Date(`${this.formateDate('yyyy-mm-dd')} ${times[0]}`),
					new Date(`${this.formateDate('yyyy-mm-dd')} ${times[1]}`),
				]
				this.ruleParam = temp
			}
			this.ruleVisible = true
		},
		confirmRule() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					const object = this.currentScopeForm()
					let data = JSON.parse(JSON.stringify(this.ruleParam))
					data.timePeriod = `${this.formateDate(
						'HH:MM',
						data.timePeriod[0]
					)}-${this.formateDate('HH:MM', data.timePeriod[1])}`
					if (this.ruleParam.index >= 0) {
						this.$set(object.SubRules, this.ruleParam.index, data)
					} else {
						let temp = JSON.parse(JSON.stringify(object.SubRules))
						data.index = temp.length
						temp.push(data)
						this.$set(object, 'SubRules', temp)
					}
					this.ruleVisible = false
				}
			})
		},
		formateDate(fmt = 'yyyy-mm-dd', date = '') {
			if (!date) {
				date = new Date()
			}

			try {
				if (typeof date == 'string') {
					date = date.replace(/-/g, '/').replace(/T/g, ' ')
					if (date.indexOf('/') == -1) {
						date = new Date(parseFloat(date))
					}
					date = new Date(date)
				} else if (typeof date == 'number') {
					date = new Date(date)
				}
			} catch (error) {
				console.log('时间格式化出错', error)
				date = new Date()
			}

			let ret
			let weak = (function (date) {
				let days = date.getDay()
				let weekArrTxt = [
					'星期天',
					'星期一',
					'星期二',
					'星期三',
					'星期四',
					'星期五',
					'星期六',
				]
				let weekArrTxt2 = [
					'周日',
					'周一',
					'周二',
					'周三',
					'周四',
					'周五',
					'周六',
				]
				return [weekArrTxt[days], weekArrTxt2[days]]
			})(date)
			const opt = {
				'y+': date.getFullYear().toString(), // 年
				'm+': (date.getMonth() + 1).toString(), // 月
				'd+': date.getDate().toString(), // 日
				'H+': date.getHours().toString(), // 时
				'M+': date.getMinutes().toString(), // 分
				'S+': date.getSeconds().toString(), // 秒
				// 有其他格式化字符需求可以继续添加，必须转化成字符串
				'W+': weak[0],
				'w+': weak[1],
			}
			for (let k in opt) {
				ret = new RegExp('(' + k + ')').exec(fmt)
				if (ret) {
					fmt = fmt.replace(
						ret[1],
						ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
					)
				}
			}
			return fmt
		},
		/**
		 * 打开查看设备弹窗。最后更新：2026-09-08
		 * @param {Object} row - 表格当前行数据
		 * @param {'out'|'in'} type - 出设备或入设备类型
		 */
		openDeviceViewDialog(row, type) {
			const isOut = type === 'out'
			const devices = isOut ? (row.OutDeviceSns || []) : (row.InDeviceSns || [])
			this.viewDeviceDialog = {
				visible: true,
				title: isOut ? '查看出设备' : '查看入设备',
				deviceType: type,
				ruleName: row.RuleName || '-',
				place: row.Place || '-',
				devices: devices,
				filterKey: '',
			}
		},
		/**
		 * 复制全部设备SN到剪贴板。最后更新：2026-09-08
		 */
		copyAllDeviceSns() {
			const devices = this.viewDeviceDialog.devices || []
			if (!devices.length) {
				this.$message.warning('暂无设备SN可复制')
				return
			}
			this.copyTextToClipboard(devices.join(','))
		},
		/**
		 * 复制单个设备SN到剪贴板。最后更新：2026-09-08
		 * @param {string} text - 待复制文本
		 */
		copySingleSn(text) {
			if (!text) return
			this.copyTextToClipboard(text)
		},
		/**
		 * 通用剪贴板复制。最后更新：2026-09-08
		 * @param {string} text - 待复制内容
		 */
		copyTextToClipboard(text) {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('已复制到剪贴板')
				}).catch(() => {
					this.fallbackCopyText(text)
				})
			} else {
				this.fallbackCopyText(text)
			}
		},
		/**
		 * 兼容性降级复制。最后更新：2026-09-08
		 * @param {string} text - 待复制内容
		 */
		fallbackCopyText(text) {
			const textarea = document.createElement('textarea')
			textarea.value = text
			textarea.style.position = 'fixed'
			textarea.style.opacity = '0'
			document.body.appendChild(textarea)
			textarea.focus()
			textarea.select()
			try {
				const successful = document.execCommand('copy')
				if (successful) {
					this.$message.success('已复制到剪贴板')
				} else {
					this.$message.error('复制失败，请手动复制')
				}
			} catch (err) {
				this.$message.error('复制失败，请手动复制')
			}
			document.body.removeChild(textarea)
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>
<style scoped>
.priority-field-wrap {
	display: flex;
	flex-direction: column;
}

.pass-status-field-wrap {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.pass-status-safe-tip {
	color: #909399;
	font-size: 12px;
	line-height: 1.4;
}

/* 日常 / 临时 Tab 与临时规则工具条。创建于 2026-10-12 */
.ac-tab-bar {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 10px;
	flex-wrap: wrap;
}

.ac-temp-toolbar {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.ac-temp-info-bar {
	box-sizing: border-box;
	min-height: 44px;
	color: #64748b;
	font-size: 12px;
}

.ac-temp-alert {
	margin-bottom: 14px;
}

.ac-time-chip {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
	line-height: 18px;
	white-space: nowrap;
}

.ac-time-chip.is-next {
	background: #fff7ed;
	color: #c2410c;
	font-weight: 600;
}

.ac-time-chip.is-doing {
	background: #eff6ff;
	color: #1d4ed8;
	font-weight: 600;
}

.ac-time-chip.is-done {
	background: #f0fdf4;
	color: #15803d;
}

.ac-time-chip.is-danger {
	background: #fef2f2;
	color: #dc2626;
	font-weight: 600;
}

.ac-time-chip.is-muted {
	color: #9ca3af;
}

.ac-time-field {
	width: 100%;
}

.ac-person-tip.ac-person-tip--empty {
	color: #dc2626;
}

.ac-third-id--removed {
	color: #9ca3af;
	text-decoration: line-through;
	cursor: help;
}

.ac-time-field >>> .el-input__inner {
	font-weight: 600;
}

.ac-time-field.is-push >>> .el-input__inner {
	border-color: #93c5fd;
	background: #eff6ff;
	color: #1d4ed8;
}

.ac-time-field.is-delete >>> .el-input__inner {
	border-color: #fdba74;
	background: #fff7ed;
	color: #c2410c;
}

.ac-time-field.is-warn >>> .el-input__inner {
	border-color: #fbbf24;
	background: #fffbeb;
	color: #b45309;
}

.ac-time-field.is-danger >>> .el-input__inner {
	border-color: #f87171;
	background: #fef2f2;
	color: #dc2626;
}

.ac-time-field.is-push >>> .el-input__prefix { color: #3b82f6; }
.ac-time-field.is-delete >>> .el-input__prefix { color: #f97316; }
.ac-time-field.is-warn >>> .el-input__prefix { color: #d97706; }
.ac-time-field.is-danger >>> .el-input__prefix { color: #ef4444; }

.ac-time-field__tip {
	margin-top: 4px;
	font-size: 12px;
	line-height: 1.4;
}

.ac-time-field.is-warn .ac-time-field__tip { color: #b45309; }
.ac-time-field.is-danger .ac-time-field__tip { color: #dc2626; }

.ac-temp-weekno-tip {
	margin: 0 0 10px 80px;
	padding: 8px 12px;
	border-radius: 4px;
	background: #f0f9ff;
	color: #0369a1;
	font-size: 12px;
	line-height: 1.6;
}

.priority-tip {
	display: block;
	margin-top: 4px;
	color: #94a3b8;
	font-size: 12px;
	line-height: 1.4;
}

.ac-rule-row-actions {
	display: inline-flex;
	flex-wrap: nowrap !important;
	align-items: center;
	justify-content: center;
	gap: 8px;
	white-space: nowrap !important;
}

.ac-rule-row-actions .el-button {
	margin: 0 !important;
	padding: 5px 12px;
}
</style>

<style>
/* 大规则「允许通行」危险确认弹窗（挂到 body，需非 scoped）。最后更新：2026-10-29 */
.ac-pass-status-danger-confirm .el-message-box__title {
	color: #f56c6c;
	font-weight: 700;
}

.ac-pass-status-danger-confirm .el-message-box__status.el-icon-error {
	color: #f56c6c;
}

.ac-pass-status-danger-confirm .el-message-box__message {
	color: #f56c6c;
}

/* 压过 dialog-theme 的 primary 蓝按钮，确认键强制红色 */
.ac-pass-status-danger-confirm .el-message-box__btns .el-button--primary,
.ac-pass-status-danger-confirm .el-message-box__btns .el-button--danger,
.ac-pass-status-danger-confirm .el-message-box__btns .ac-pass-status-danger-btn {
	background: #f56c6c !important;
	border-color: #f56c6c !important;
	color: #fff !important;
}

.ac-pass-status-danger-confirm .el-message-box__btns .el-button--primary:hover,
.ac-pass-status-danger-confirm .el-message-box__btns .el-button--primary:focus,
.ac-pass-status-danger-confirm .el-message-box__btns .el-button--danger:hover,
.ac-pass-status-danger-confirm .el-message-box__btns .el-button--danger:focus,
.ac-pass-status-danger-confirm .el-message-box__btns .ac-pass-status-danger-btn:hover,
.ac-pass-status-danger-confirm .el-message-box__btns .ac-pass-status-danger-btn:focus {
	background: #f78989 !important;
	border-color: #f78989 !important;
	color: #fff !important;
}

/* 门禁规则：人员/设备选择弹窗。最后修改：2026-09-08 */
.ac-person-dialog {
	min-height: 650px;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
}

.ac-person-dialog .el-dialog__header {
	flex-shrink: 0;
	padding: 16px 20px 12px;
	border-bottom: 1px solid #f1f5f9;
}

.ac-person-dialog .el-dialog__body {
	flex: 1;
	min-height: 0;
	padding: 16px 20px 12px !important;
	overflow: hidden !important; /* 关键：彻底禁止弹窗整体滑动 */
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
}

.ac-person-dialog .el-dialog__footer {
	flex-shrink: 0;
	padding: 12px 20px 14px;
	border-top: 1px solid #f1f5f9;
}

.ac-person-dialog-footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	width: 100%;
	box-sizing: border-box;
}

.ac-person-footer-btns {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 10px;
}

.ac-person-dialog-container {
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
	overflow: hidden;
}

.ac-picker-dialog .el-dialog__body {
	padding: 16px 20px 20px;
}

/* 弹窗顶部通栏：左侧胶囊 Tab，右侧状态上下文与提示。最后修改：2026-09-08 */
.ac-picker-header-bar {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 12px;
	min-height: 38px;
}

.ac-picker-tabs {
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	gap: 12px;
}

/* 现代精致分段选择器（Segmented Pills） */
.ac-segmented-group.el-radio-group {
	background: #f1f5f9;
	padding: 3px;
	border-radius: 8px;
	border: 1px solid #e2e8f0;
	display: inline-flex;
	align-items: center;
	gap: 2px;
}

.ac-segmented-group .el-radio-button__inner {
	border: none !important;
	border-radius: 6px !important;
	background: transparent;
	color: #64748b;
	font-size: 13px;
	font-weight: 500;
	padding: 7px 14px;
	box-shadow: none !important;
	transition: all 0.18s ease;
}

.ac-segmented-group .el-radio-button__inner:hover {
	color: #1e293b;
}

.ac-segmented-group .el-radio-button.is-active .el-radio-button__inner {
	background: #ffffff !important;
	color: #2563eb !important;
	font-weight: 600;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.ac-segmented-group .scope-count-badge {
	margin-left: 4px;
	font-size: 12px;
	font-weight: 700;
	color: #94a3b8;
}

.ac-segmented-group .el-radio-button.is-active .scope-count-badge {
	color: #2563eb;
}

/* 顶部右侧上下文状态栏（消除原白板区域，避免字符重叠） */
.ac-picker-context-bar {
	flex: 1;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.ac-context-item {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	justify-content: flex-end;
}

.ac-context-hint {
	font-size: 12px;
	color: #94a3b8;
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.ac-tree-header-tag {
	flex-shrink: 0;
	height: 36px;
	line-height: 36px;
	padding: 0 12px;
	font-size: 13px;
	font-weight: 600;
	color: #1e293b;
	background: #f8fafc;
	border-bottom: 1px solid #f1f5f9;
	display: flex;
	align-items: center;
	gap: 6px;
	box-sizing: border-box;
}

.ac-tree-header-tag i {
	color: #2563eb;
}

/* 弹窗高度全面提升（高度调整为 500px，容量充沛，兼顾各分辨率屏幕）。最后修改：2026-09-08 */
.ac-picker-body {
	height: 500px;
	min-height: 480px;
	max-height: 520px;
	overflow: hidden;
	box-sizing: border-box;
}

.ac-picker-body--dept {
	height: 560px;
	min-height: 520px;
	max-height: 580px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	background: #fff;
	overflow: hidden;
	box-sizing: border-box;
	padding: 0;
}

.ac-picker-body--tree-only {
	display: flex;
}

.ac-picker-body--split {
	display: flex;
	gap: 12px;
	height: 520px;
	min-height: 500px;
	max-height: 540px;
	align-items: stretch;
	overflow: hidden;
	box-sizing: border-box;
}

/* 学生 Tab：对齐 PersonScope 左树右表。最后更新：2026-10-29 */
.ac-picker-body--ps {
	height: 560px;
	min-height: 520px;
	max-height: 580px;
	display: flex;
	padding: 0;
	overflow: hidden;
	box-sizing: border-box;
}

.ac-ps-layout.ps-layout {
	flex: 1;
	width: 100%;
	height: 100%;
	max-height: none;
	min-height: 0;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	overflow: hidden;
	background: #fff;
	display: flex;
	gap: 0;
}

.ac-ps-layout .ps-left {
	width: 300px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	border-right: 1px solid #e2e8f0;
	background: #fff;
	min-height: 0;
	overflow: hidden;
}

.ac-ps-layout .ps-left-header {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 12px 14px 8px;
	font-size: 14px;
	font-weight: 600;
	color: #0f172a;
	flex-shrink: 0;
}

.ac-ps-layout .ps-left-header i {
	color: var(--btn-primary, #2563eb);
}

/* 与 PersonScopeMultiPicker 固定范围条一致（非重复标题）。最后更新：2026-10-29 */
.ac-ps-layout .ps-scope-fixed {
	margin: 0 12px 10px;
	padding: 8px 10px;
	border-radius: 6px;
	background: #eff6ff;
	border: 1px solid #bfdbfe;
	color: #1d4ed8;
	font-size: 13px;
	font-weight: 600;
	display: flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
}

.ac-ps-layout .ps-left-search {
	padding: 0 12px 10px;
	flex-shrink: 0;
}

.ac-ps-layout .ps-left-tree {
	flex: 1;
	min-height: 0;
	overflow: auto;
	padding: 0 8px 12px;
	box-sizing: border-box;
}

.ac-ps-layout .ps-left-tree >>> .el-tree-node__content {
	height: 34px;
	border-radius: 6px;
}

.ac-ps-layout .ps-left-tree >>> .el-tree-node.is-current > .el-tree-node__content {
	background: #dbeafe;
}

.ac-ps-layout .ps-tree-node {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	min-width: 0;
}

.ac-ps-layout .ps-tree-node__dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	flex-shrink: 0;
	background: #94a3b8;
}

.ac-ps-layout .ps-tree-node__dot.tone-school { background: #2563eb; }
.ac-ps-layout .ps-tree-node__dot.tone-campus { background: #f59e0b; }
.ac-ps-layout .ps-tree-node__dot.tone-period { background: #8b5cf6; }
.ac-ps-layout .ps-tree-node__dot.tone-grade { background: #06b6d4; }
.ac-ps-layout .ps-tree-node__dot.tone-class { background: #64748b; }
.ac-ps-layout .ps-tree-node__dot.tone-internal { background: #0ea5e9; }

.ac-ps-layout .ps-tree-node__label {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: #334155;
	font-size: 13px;
}

.ac-ps-layout .ps-right {
	flex: 1;
	min-width: 0;
	min-height: 0;
	display: flex;
	flex-direction: column;
	padding: 12px 16px 10px;
	overflow: hidden;
}

.ac-ps-layout .ps-meta {
	margin-bottom: 10px;
	color: #475569;
	font-size: 13px;
	flex-shrink: 0;
}

.ac-ps-layout .ac-student-meta {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
}

.ac-ps-layout .ac-student-meta__left {
	flex: 1;
	min-width: 0;
	line-height: 1.5;
}

.ac-ps-layout .ac-student-view-mode {
	flex-shrink: 0;
}

.ac-ps-layout.is-selected-view .ps-right {
	width: 100%;
}

.ac-ps-layout .ac-ps-remove-btn {
	color: #dc2626;
	padding: 0;
}

.ac-ps-layout .ps-meta-sep {
	margin: 0 6px;
	color: #cbd5e1;
}

.ps-delta {
	font-weight: 600;
	margin-right: 4px;
}

.ps-delta--add {
	color: #059669;
}

.ps-delta--del {
	color: #dc2626;
}

.ac-ps-layout .ps-filter-bar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
	margin-bottom: 8px;
	flex-shrink: 0;
}

.ac-ps-layout .ps-name-input {
	width: 160px;
}

.ac-ps-layout .ac-ps-filter-select {
	width: 140px;
}

.ac-ps-layout .ac-ps-filter-select--tag {
	width: 200px;
}

.ac-ps-layout .ac-ps-clear-all {
	margin-left: auto;
}

.ac-ps-layout .ps-hint {
	font-size: 13px;
	color: #475569;
	margin-bottom: 8px;
	flex-shrink: 0;
}

.ac-ps-layout .ps-hint-sub {
	color: #64748b;
	margin-left: 4px;
}

.ac-ps-layout .ps-hint--warn {
	color: #b45309;
}

.ac-ps-layout .ps-table-wrap {
	flex: 1 1 0;
	min-height: 0;
	height: 0;
	margin-bottom: 4px;
	overflow: hidden;
}

.ac-ps-layout .ps-table-wrap .el-table {
	width: 100%;
}

.ac-ps-layout .ps-table-wrap .el-table__body tr {
	cursor: pointer;
}

.ac-ps-layout .ps-avatar-empty {
	color: #c0c4cc;
	font-size: 12px;
}

.ac-ps-layout .ps-pager-wrap {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	flex-shrink: 0;
}

/* 部门切换标签条：顶栏铺满。最后更新：2026-10-29 */
.dept-scope-bar {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
	margin: 0;
	padding: 10px 14px;
	border-bottom: 1px solid #e2e8f0;
	background: #f8fafc;
	box-sizing: border-box;
}

.dept-scope-btn {
	flex: 0 0 auto;
	min-width: 148px;
	margin: 0;
	padding: 7px 14px;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	background: #fff;
	color: #64748b;
	font-size: 13px;
	font-weight: 500;
	font-family: inherit;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	transition: border-color .15s ease, color .15s ease, background .15s ease;
}

.dept-scope-btn:hover {
	border-color: #93c5fd;
	color: #2563eb;
}

.dept-scope-btn.is-active {
	border-color: #2563eb;
	background: #eff6ff;
	color: #1d4ed8;
	font-weight: 600;
}

.dept-scope-btn .scope-count-badge {
	color: #2563eb;
	font-weight: 700;
	font-size: 12px;
}

.ac-scope-bar--compact {
	padding: 6px 8px;
	gap: 4px;
	background: #f1f5f9;
}

.ac-scope-bar--compact .dept-scope-btn {
	padding: 5px 6px;
	font-size: 12px;
	border-radius: 4px;
}

/* 部门树面板：铺满弹窗可用区。最后更新：2026-10-29 */
.ac-dept-panel-wrap {
	flex: 1;
	min-height: 0;
	height: 0;
	padding: 12px 14px 14px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	box-sizing: border-box;
	width: 100%;
	margin: 0;
	background: #fff;
	border: none;
	border-radius: 0;
}

.ac-dept-tree-panel {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	height: 100%;
	overflow: hidden;
}

.ac-tree-search-bar {
	flex-shrink: 0;
	margin-bottom: 8px;
}

.ac-tree-search-bar--compact {
	flex-shrink: 0;
	padding: 8px;
	border-bottom: 1px solid #f1f5f9;
	box-sizing: border-box;
}

.ac-dept-tree-panel .ac-tree-scroll {
	flex: 1;
	min-height: 0;
	height: 0;
	overflow-y: auto;
	overflow-x: auto;
	border: 1px solid #f1f5f9;
	border-radius: 6px;
	padding: 6px;
	background: #fafbfc;
	box-sizing: border-box;
}

.ac-tree-scroll {
	flex: 1;
	height: 330px;
	overflow-y: auto;
	border: 1px solid #f1f5f9;
	border-radius: 6px;
	padding: 6px;
	background: #fafbfc;
}

.ac-tree-scroll--narrow {
	flex: 1;
	min-height: 0;
	height: 0; /* 关键：触发 flex 内部自动计算，防止树节点撑大父容器 */
	overflow-y: auto;
	overflow-x: auto;
	padding: 6px 8px;
	border: none;
	background: transparent;
	box-sizing: border-box;
}

/* 内部滚动条精致样式 */
.ac-tree-scroll::-webkit-scrollbar,
.ac-tree-scroll--narrow::-webkit-scrollbar,
.ac-person-picker-tree::-webkit-scrollbar {
	width: 5px;
	height: 5px;
}

.ac-tree-scroll::-webkit-scrollbar-track,
.ac-tree-scroll--narrow::-webkit-scrollbar-track,
.ac-person-picker-tree::-webkit-scrollbar-track {
	background: #f8fafc;
	border-radius: 4px;
}

.ac-tree-scroll::-webkit-scrollbar-thumb,
.ac-tree-scroll--narrow::-webkit-scrollbar-thumb,
.ac-person-picker-tree::-webkit-scrollbar-thumb {
	background: #cbd5e1;
	border-radius: 4px;
}

.ac-tree-scroll::-webkit-scrollbar-thumb:hover,
.ac-tree-scroll--narrow::-webkit-scrollbar-thumb:hover,
.ac-person-picker-tree::-webkit-scrollbar-thumb:hover {
	background: #94a3b8;
}

/* 统一部门树视觉体系（参考 DepartmentPane 统一样式）。创建于 2026-09-08 */
.ac-person-dialog .tree-search-input .el-input__inner {
	border-radius: 6px;
	background-color: #f8fafc;
	border: 1px solid #e2e8f0;
	color: #1e293b;
	transition: border-color 0.18s ease, background-color 0.18s ease, box-shadow 0.18s ease;
}

.ac-person-dialog .tree-search-input .el-input__inner:focus {
	border-color: #2563eb;
	background-color: #ffffff;
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.ac-person-dialog .el-tree {
	background: transparent;
	padding: 2px 0 6px;
	width: 100%;
	box-sizing: border-box;
	color: #1e293b;
}

.ac-person-dialog .el-tree-node {
	min-width: 0;
	width: 100%;
	box-sizing: border-box;
}

.ac-person-dialog .el-tree-node__content {
	height: 32px;
	margin: 1px 4px;
	padding-right: 6px;
	border-radius: 6px;
	transition: background-color 0.18s ease, color 0.18s ease;
	color: #1e293b;
	box-sizing: border-box;
	width: auto;
	max-width: calc(100% - 8px);
}

.ac-person-dialog .el-tree-node__content:hover {
	background-color: #f1f5f9;
}

/* 高亮当前选中行（如学生/教职工左侧选中的班级或部门） */
.ac-person-dialog .el-tree-node.is-current > .el-tree-node__content {
	background-color: #eff6ff;
	color: #2563eb;
	font-weight: 600;
}

.ac-person-dialog .el-tree-node.is-current > .el-tree-node__content .el-tree-node__expand-icon {
	color: #2563eb;
}

.ac-person-dialog .el-tree-node__expand-icon {
	color: #94a3b8;
	font-size: 12px;
	padding: 4px;
	flex-shrink: 0;
}

/* 隐藏叶子节点展开图标，保留占位对齐缩进 */
.ac-person-dialog .el-tree-node__expand-icon.is-leaf {
	visibility: hidden;
}

/* 复选框微调对齐 */
.ac-person-dialog .el-tree-node__content .el-checkbox {
	margin-right: 6px;
}

/* 自定义节点容器 */
.ac-person-dialog .tree-node {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	min-width: 0;
	flex: 1;
	max-width: 100%;
	overflow: hidden;
	padding-right: 2px;
}

/* 节点组织类型彩色小圆点（Tone体系，与平台统一） */
.ac-person-dialog .tree-node__dot {
	width: 7px;
	height: 7px;
	border-radius: 50%;
	flex-shrink: 0;
	background: #94a3b8;
}

.ac-person-dialog .tree-node__dot.tone-school { background: #2563eb; }
.ac-person-dialog .tree-node__dot.tone-campus { background: #f59e0b; }
.ac-person-dialog .tree-node__dot.tone-period { background: #8b5cf6; }
.ac-person-dialog .tree-node__dot.tone-grade { background: #06b6d4; }
.ac-person-dialog .tree-node__dot.tone-class { background: #3b82f6; }
.ac-person-dialog .tree-node__dot.tone-internal { background: #10b981; }
.ac-person-dialog .tree-node__dot.tone-platform { background: #f59e0b; }
.ac-person-dialog .tree-node__dot.tone-default { background: #94a3b8; }

/* 节点文字 */
.ac-person-dialog .tree-node__label {
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 13px;
	line-height: 1.4;
}

/* 节点悬停小箭头 */
.ac-person-dialog .tree-node__arrow {
	font-size: 12px;
	color: #cbd5e1;
	opacity: 0;
	transition: opacity 0.18s ease;
	flex-shrink: 0;
	margin-left: auto;
}

.ac-person-dialog .el-tree-node__content:hover .tree-node__arrow,
.ac-person-dialog .el-tree-node.is-current > .el-tree-node__content .tree-node__arrow {
	opacity: 1;
	color: #2563eb;
}

.ac-picker-status-tip {
	flex-shrink: 0;
	margin: 0;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 5px 12px;
	background: #eff6ff;
	border: 1px solid #dbeafe;
	border-radius: 6px;
	color: #1e40af;
	font-size: 13px;
	box-sizing: border-box;
	line-height: 20px;
}

.ac-picker-status-tip strong {
	color: #1d4ed8;
	font-size: 13px;
	font-weight: 600;
}

/* 人员模式左侧树与右侧穿梭框 */
.ac-picker-tree {
	flex: 0 0 240px;
	min-width: 220px;
	max-width: 260px;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	padding: 10px;
	overflow: auto;
	background: #fafbfc;
	box-sizing: border-box;
}

.ac-person-picker-tree {
	height: 100%;
	max-height: 100%;
	flex: 0 0 200px;
	width: 200px;
	min-width: 200px;
	max-width: 200px;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	background: #fafbfc;
	padding: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	box-sizing: border-box;
}

.ac-picker-tree--full {
	flex: 1;
	max-width: none;
}

.ac-picker-transfer {
	flex: 1;
	min-width: 0;
	height: 100%;
	max-height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	box-sizing: border-box;
}

.ac-transfer-top-bar {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 4px 4px 8px;
	gap: 12px;
}

.ac-transfer-top-left {
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
}

.ac-transfer-panel-title {
	font-size: 13px;
	font-weight: 600;
	color: #334155;
	display: inline-flex;
	align-items: center;
	gap: 6px;
}

.ac-transfer-panel-title i {
	color: #2563eb;
}

.ac-transfer-retain-tag {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 12px;
	color: #059669;
	background: #ecfdf5;
	border: 1px solid #a7f3d0;
	border-radius: 4px;
	padding: 2px 8px;
	font-weight: 500;
	line-height: 18px;
	white-space: nowrap;
}

.ac-current-dept-tag {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	font-size: 13px;
	color: #334155;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	padding: 4px 10px;
	border-radius: 6px;
	white-space: nowrap;
}

.ac-current-dept-tag strong {
	color: #2563eb;
	font-weight: 600;
}

.ac-transfer-search-name {
	width: 180px;
	flex-shrink: 0;
}

.ac-transfer-bottom-tip {
	flex-shrink: 0;
	margin-top: 6px;
	font-size: 12px;
	color: #64748b;
	text-align: right;
}

.ac-transfer-bottom-tip strong {
	color: #059669;
}

.ac-device-transfer-body {
	display: flex;
	flex-direction: column;
	min-height: 360px;
}

.ac-device-dialog .el-dialog__body {
	padding: 16px 20px 14px;
	overflow: hidden !important;
}

.ac-picker-transfer .el-transfer.ac-transfer {
	width: 100%;
	flex: 1;
	min-height: 0;
	height: 100%;
	display: flex;
	align-items: stretch;
	justify-content: center;
}

.ac-device-transfer-body .el-transfer.ac-transfer {
	width: 100%;
	display: flex;
	align-items: stretch;
	justify-content: center;
}

.ac-picker-transfer .el-transfer.ac-transfer .el-transfer-panel {
	flex: 1;
	width: auto !important;
	min-width: 0;
	max-width: none;
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border-radius: 8px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
	overflow: hidden;
}

.ac-device-transfer-body .el-transfer.ac-transfer .el-transfer-panel {
	flex: 1;
	width: auto !important;
	min-width: 280px;
	max-width: none;
	border-radius: 8px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

/* 设备名较长：保证 label 占满面板剩余宽度。最后更新：2026-09-14 */
.ac-device-transfer-body .el-transfer-panel__item.el-checkbox {
	display: block !important;
	height: 32px;
	line-height: 32px;
	padding-left: 14px;
	margin-right: 0;
	box-sizing: border-box;
}

/* 复选框为绝对定位，label 需保留 24px 左内边距避免与复选框重叠。最后更新：2026-10-09 */
.ac-device-transfer-body .el-transfer-panel__item .el-checkbox__label {
	width: 100%;
	padding-left: 24px;
	line-height: 32px;
	box-sizing: border-box;
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.ac-device-transfer-body .el-transfer-panel__item .el-checkbox__input,
.ac-picker-transfer .el-transfer-panel__item .el-checkbox__input {
	top: 9px;
}

.ac-picker-transfer .el-transfer.ac-transfer .el-transfer-panel__header {
	flex-shrink: 0;
}

.ac-picker-transfer .el-transfer.ac-transfer .el-transfer-panel__body {
	flex: 1 !important;
	min-height: 0 !important;
	height: auto !important;
	display: flex !important;
	flex-direction: column !important;
	overflow: hidden !important;
}

.ac-device-transfer-body .el-transfer.ac-transfer .el-transfer-panel__body {
	height: 340px;
}

.ac-picker-transfer .el-transfer.ac-transfer .el-transfer-panel__filter {
	flex-shrink: 0 !important;
	margin: 10px 12px 6px !important;
}

.ac-picker-transfer .el-transfer.ac-transfer .el-transfer-panel__list,
.ac-picker-transfer .el-transfer.ac-transfer .el-transfer-panel__list.is-filterable {
	flex: 1 !important;
	min-height: 0 !important;
	height: auto !important;
	max-height: none !important;
	overflow-y: auto !important;
	padding: 4px 0 12px !important; /* 关键：底部预留 12px 安全内边距，保证最后一项 100% 完整显示 */
	box-sizing: border-box !important;
}

/* 1000人超长列表极速渲染优化：启用现代 Chromium 原生视口跳过（GPU虚拟列表渲染），秒级极速流畅 */
.ac-picker-transfer .el-transfer-panel__item.el-checkbox {
	display: block !important;
	height: 32px;
	line-height: 32px;
	padding-left: 14px;
	margin-right: 0;
	content-visibility: auto;
	contain-intrinsic-size: 32px;
	box-sizing: border-box;
}

.ac-picker-transfer .el-transfer-panel__item.el-checkbox:hover {
	background-color: #f8fafc;
	color: #2563eb;
}

.ac-picker-transfer .el-transfer-panel__item .el-checkbox__label {
	font-size: 13px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* 学生紧凑工具条：单行下拉 + 勾选。最后更新：2026-10-29 */
.ac-student-toolbar {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 0 0 8px;
	padding: 8px 10px;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	min-width: 0;
}
.ac-toolbar-select {
	width: 140px;
	flex-shrink: 0;
}
.ac-toolbar-select--tag {
	width: 200px;
}
.ac-toolbar-hint {
	flex: 1;
	min-width: 0;
	font-size: 12px;
	color: #94a3b8;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* 学生穿梭框：姓名 + 短类型徽标，标签详情放悬停 title。最后更新：2026-10-29 */
.ac-student-transfer .el-transfer-panel__item {
	height: 34px;
	line-height: 34px;
	contain-intrinsic-size: 34px;
}
.ac-student-transfer .el-transfer-panel__item .el-checkbox__label {
	width: 100%;
	padding-left: 24px;
	line-height: 34px;
	box-sizing: border-box;
	display: block;
}

.ac-student-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	width: 100%;
	height: 34px;
	line-height: 20px;
}

.ac-student-name {
	font-size: 13px;
	color: #0f172a;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex: 1;
	min-width: 0;
}

.ac-student-tag {
	display: inline-block;
	max-width: 100%;
	font-size: 12px;
	line-height: 20px;
	padding: 0 7px;
	border-radius: 999px;
	font-weight: 500;
	flex-shrink: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: middle;
	box-sizing: border-box;
}

.ac-student-tag-count {
	flex-shrink: 0;
	font-size: 11px;
	color: #64748b;
	background: #f1f5f9;
	border: 1px solid #e2e8f0;
	border-radius: 4px;
	padding: 0 5px;
	line-height: 16px;
}

/* live_home：清爽蓝徽章 */
.ac-student-tag.tag-day {
	background-color: #eff6ff;
	color: #2563eb;
	border: 1px solid #bfdbfe;
}

/* live_school：典雅紫徽章 */
.ac-student-tag.tag-board {
	background-color: #f5f3ff;
	color: #7c3aed;
	border: 1px solid #ddd6fe;
}

/* live_home_spe：琥珀橙徽章 */
.ac-student-tag.tag-special {
	background-color: #fffbeb;
	color: #d97706;
	border: 1px solid #fde68a;
}

/* 默认/其他类型：中性灰蓝徽章 */
.ac-student-tag.tag-default {
	background-color: #f1f5f9;
	color: #475569;
	border: 1px solid #e2e8f0;
}

/* 穿梭框内部滚动条精致样式 */
.ac-picker-transfer .el-transfer-panel__list::-webkit-scrollbar,
.ac-device-transfer-body .el-transfer-panel__list::-webkit-scrollbar {
	width: 5px;
	height: 5px;
}

.ac-picker-transfer .el-transfer-panel__list::-webkit-scrollbar-thumb,
.ac-device-transfer-body .el-transfer-panel__list::-webkit-scrollbar-thumb {
	background-color: #cbd5e1;
	border-radius: 4px;
}

.ac-picker-transfer .el-transfer-panel__list::-webkit-scrollbar-thumb:hover,
.ac-device-transfer-body .el-transfer-panel__list::-webkit-scrollbar-thumb:hover {
	background-color: #94a3b8;
}

.ac-device-transfer-body .el-transfer.ac-transfer .el-transfer-panel__list,
.ac-device-transfer-body .el-transfer.ac-transfer .el-transfer-panel__list.is-filterable {
	height: 292px;
}

.ac-picker-transfer .el-transfer.ac-transfer .el-transfer__buttons,
.ac-device-transfer-body .el-transfer.ac-transfer .el-transfer__buttons {
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0 12px;
}

.ac-picker-transfer .el-transfer.ac-transfer .el-transfer__button,
.ac-device-transfer-body .el-transfer.ac-transfer .el-transfer__button {
	margin: 0 0 8px;
}

.ac-picker-transfer .el-transfer.ac-transfer .el-transfer__button:last-child,
.ac-device-transfer-body .el-transfer.ac-transfer .el-transfer__button:last-child {
	margin-bottom: 0;
}

/* 编辑/新增门禁规则：body 可滚；表单不再单独限高避免双层裁切。最后更新：2026-09-14 */
.ac-rule-dialog {
	min-width: 840px;
	max-width: 1100px;
	border-radius: 8px;
}

.ac-rule-dialog .el-dialog__body {
	max-height: calc(100vh - 12vh - 140px) !important;
	max-height: calc(100dvh - 12vh - 140px) !important;
	overflow-y: auto !important;
}

.ac-rule-dialog .addForm,
.ac-rule-dialog .editForm,
.AccessControl-Rules .addForm,
.AccessControl-Rules .editForm {
	max-height: none;
	overflow: visible;
	padding-right: 0;
}

.AccessControl-Rules .addForm .el-row,
.AccessControl-Rules .editForm .el-row {
	margin-bottom: 0;
}

.AccessControl-Rules .addForm .tip,
.AccessControl-Rules .editForm .tip {
	margin-left: 16px;
	color: #94a3b8;
	font-size: 13px;
	display: inline-flex;
	align-items: center;
	vertical-align: middle;
}

.AccessControl-Rules .addForm .isSelect,
.AccessControl-Rules .editForm .isSelect {
	color: #059669;
}

.ac-person-form-item .el-form-item__content,
.ac-action-form-item .el-form-item__content {
	display: flex;
	align-items: center;
}

.ac-person-tip,
.ac-action-tip,
.ac-person-form-item .el-button + span,
.ac-action-form-item .el-button + span {
	margin-left: 16px !important;
}

/* 出入门禁规则容器：两个方向面板上下排列。最后修改：2026-10-09 */
.ac-rule-tabs-wrap {
	margin-top: 16px;
	margin-bottom: 12px;
	border: 1px solid #e2e8f0;
	border-radius: 10px;
	background: #ffffff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	overflow: hidden;
}

.ac-direction-panel {
	border: none;
	border-radius: 0;
	padding: 12px 14px 8px;
	background: #fff;
}

.ac-direction-panel + .ac-direction-panel {
	border-top: 1px solid #e2e8f0;
}

/* 门禁人员类型本校别名（勾选框副标 + 提示）。创建于 2026-10-16 */
.ac-role-alias {
	margin-left: 4px;
	color: #64748b;
	font-size: 12px;
	font-weight: 400;
}

.ac-role-alias::before {
	content: '·';
	margin-right: 2px;
}

.ac-role-alias-hint {
	margin-top: 6px;
	color: #94a3b8;
	font-size: 12px;
	line-height: 1.4;
}

/* 规则人员类型标签：每个类型独立成签，避免逗号串在窄列中断行。创建于 2026-10-09 */
.ac-role-tags {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 4px;
}

.ac-role-tag {
	display: inline-block;
	padding: 0 8px;
	font-size: 12px;
	line-height: 20px;
	border-radius: 10px;
	white-space: nowrap;
	border: 1px solid #e2e8f0;
	background: #f8fafc;
	color: #475569;
}

.ac-role-tag--0 {
	color: #0369a1;
	background: #f0f9ff;
	border-color: #bae6fd;
}

.ac-role-tag--1 {
	color: #7c3aed;
	background: #f5f3ff;
	border-color: #ddd6fe;
}

.ac-role-tag--2 {
	color: #b45309;
	background: #fffbeb;
	border-color: #fde68a;
}

.ac-role-tag--3 {
	color: #047857;
	background: #ecfdf5;
	border-color: #a7f3d0;
}

/* 规则周期与时间醒目显示，便于核对生效时段。创建于 2026-10-09 */
.ac-rule-time-highlight {
	color: #dc2626;
	font-weight: 600;
}

/* 出入门禁方向面板工具栏：单行两端分布，省出垂直空间并充实右侧。最后修改：2026-09-08 */
.ac-direction-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 12px;
	padding: 8px 14px;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	box-sizing: border-box;
}

.ac-direction-toolbar-left {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.ac-direction-toolbar .ac-toolbar-label {
	font-size: 13px;
	font-weight: 600;
	color: #1e293b;
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.ac-direction-toolbar .ac-action-tip {
	margin-left: 8px !important;
	font-size: 13px;
}

.ac-direction-toolbar-right {
	flex-shrink: 0;
	display: flex;
	align-items: center;
}

.ac-rule-table-item {
	margin-bottom: 0 !important;
}

.ac-rule-table-item .el-form-item__content {
	margin-left: 0 !important;
}

/* 列表出/入设备快速查看链接按钮。最后修改：2026-09-08 */
.ac-device-link-btn {
	padding: 4px 10px;
	font-size: 13px;
	color: #2563eb;
	background-color: #eff6ff;
	border-radius: 4px;
	line-height: 18px;
	border: 1px solid #bfdbfe;
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.ac-device-link-btn:hover,
.ac-device-link-btn:focus {
	color: #1d4ed8;
	background-color: #dbeafe;
	border-color: #93c5fd;
}

.ac-empty-dash {
	color: #94a3b8;
}

/* 查看设备弹窗。最后修改：2026-09-08 */
.ac-device-view-dialog .el-dialog__body {
	padding: 16px 20px;
}

.ac-device-view-header {
	margin-bottom: 12px;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.ac-device-view-info {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	font-size: 13px;
	color: #475569;
	background-color: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	padding: 8px 12px;
}

.ac-device-view-info-item .info-label {
	color: #64748b;
}

.ac-device-view-info-item .info-val {
	font-weight: 500;
	color: #1e293b;
}

.ac-device-view-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.ac-device-sn-code {
	font-family: Consolas, Monaco, monospace;
	font-size: 13px;
	color: #0f172a;
	font-weight: 500;
}

/* 门禁方向规则表格操作列：一行横向并排展示两个按钮。最后修改：2026-09-08 */
.ac-direction-panel .el-table .ac-rule-row-actions {
	display: inline-flex !important;
	flex-wrap: nowrap !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 8px !important;
	white-space: nowrap !important;
	width: 100%;
}

.ac-direction-panel .el-table .ac-rule-row-actions .el-button {
	margin: 0 !important;
	padding: 5px 12px !important;
}
</style>

<style scoped>
.scheme-page-bar {
	display: flex;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
	padding: 8px 12px;
	margin-bottom: 8px;
	background: #f5f7fa;
	border-radius: 4px;
}
.scheme-page-actions {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	margin-left: auto;
}
.scheme-pick {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
}
.scheme-pick-card {
	position: relative;
	padding: 16px 14px;
	border: 1px solid #e4e7ed;
	border-radius: 8px;
	background: #fafbfc;
	cursor: pointer;
	transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
	user-select: none;
}
.scheme-pick-card:hover:not(.is-disabled) {
	border-color: #c0c4cc;
	background: #fff;
}
.scheme-pick-card.is-active {
	border-color: #409eff;
	background: #ecf5ff;
	box-shadow: 0 0 0 1px #409eff inset;
}
.scheme-pick-card.is-disabled {
	opacity: 0.55;
	cursor: not-allowed;
}
.scheme-pick-card__top {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
	min-height: 22px;
}
.scheme-pick-card__icon {
	font-size: 18px;
	color: #909399;
}
.scheme-pick-card.is-active .scheme-pick-card__icon {
	color: #409eff;
}
.scheme-pick-badge {
	font-size: 12px;
	line-height: 18px;
	padding: 0 6px;
	border-radius: 3px;
	color: #67c23a;
	background: #f0f9eb;
}
.scheme-pick-badge.is-muted {
	color: #909399;
	background: #f4f4f5;
}
.scheme-pick-card__name {
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	line-height: 1.3;
	word-break: break-all;
}
.scheme-pick-card__desc {
	margin-top: 6px;
	font-size: 12px;
	color: #909399;
}
</style>
